import React, { useState, useEffect } from "react";
import "../../assets/css/candidate-tab-form.css";
import "../../assets/css/inner-tabs.css";
import { useDispatch, useSelector } from "react-redux";
import {
  addEmployment,
  removeEmployment,
  saveEmployment,
  deleteSaveEmployment,
  deleteAddEmploymentData,
  getPreviousEmploymentCount,
  deletePrevEmploymentCountData,
  getReasonOfLeavingOptions,
} from "../../Actions/employmentActions";

import { uploadFileViaMultipart } from "../../Actions/uploadFileActions";
import EMPMultipleUpload from "./empMultipleUpload";
import EMPRadio from "./empRadio";
import EMPText from "./empText";
import EMPCheckbox from "./empCheckbox";
import EMPSimpleSelect from "./empSimpleSelect";
import EMPDate from "./empDate";
import EMPAutoCompleteSelect from "./empAutoCompleteSelect";
import EmploymentGaps from "../EmploymentGaps";
import _ from "lodash";
import {
  hrAndRMFields,
  excludedFields,
  instantModesFields,
  form16Fields,
  UAN,
  employeeValidationViaOTP,
  corporateEmailValidation,
  bankStatementAnalyser,
  bankStatementThroughNetBanking,
  documentCheckboxDisabledClients,
} from "./empConstants";
import {
  validateEmail,
  validateContactNumber,
  validateUAN,
  validateSSN,
  validatePAN,
  validateMobileNumber711,
  validateAlphabetsAndSpace,
  validateNumeric,
  checkEmployeeCode,
} from "../../Helper/common";
import { FOLDERPATH } from "../../Constants/config";
import EMPSingleFileUpload from "./empSingleFileUpload";
import Loader from "../Common/loader";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ConfirmationPopup from "./confirmationPopup";
import TenureAlertPopUp from "./TenureAlertPopUp";
import { toast } from "react-toastify";

import { dateFormat } from "../../Helper/common";
import AlertPopup from "./AlertPopUp";
import { getMRLDocument } from "../../Actions/educationActions";

const instantFieldsMapping = {
  1: form16Fields,
  2: UAN,
  3: employeeValidationViaOTP,
  4: corporateEmailValidation,
  5: bankStatementAnalyser,
  6: bankStatementThroughNetBanking,
};

const numbers711 = [
  "employment_cand_mobile_no",
  "hr_mobile_no",
  "manager_mobile_no",
  "manager_mobile_no1",
];
const alphabetsAndSpace = [
  "manager_first_name",
  "manager_first_name1",
  "manager_last_name",
  "manager_last_name1",
  "manager_middle_name",
  "manager_middle_name1",
];

const numericOnly = ["cost_to_company"];

const MainForm = ({
  emp,
  active,
  reference,
  states,
  currencies,
  countryCodeOptions,
  isLoading,
  setIsLoading,
  reRenderAgain,
  refreshData,
  backHandler,
  showAddPopup,
  closeAddPopup,
  proceedAdd,
  redirectToTabOne,
  caseStatusCheckDetails,
  unsavedErrorData,
  handleUnsavedErrorData,
  showAlertPopUp,
  setShowAlertPopUp,
  previousEmpoymentCountPopUp,
  setPreviousEmploymentCountPopUp,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [employment, setEmployment] = useState({});
  const [errorData, setErrorData] = useState([]);
  // const [unsavedErrorData, setUnsavedErrorData] = useState([]);
  const [currentField, setCurrentField] = useState(null);
  const [onContract, setonContract] = useState([]);
  const [isSelfEmployed, setIsSelfEmployed] = useState([]);
  const [isSSN, setIsSSN] = useState(false);
  const [tillDateChecked, setTillDateChecked] = useState({});
  const [canConnectWithManager, setCanConnectWithManager] = useState([]);
  const [canConnectWithManager1, setCanConnectWithManager1] = useState([]);
  const [isDocProvidedChecked, setIsDocProvidedChecked] = useState({});
  const [instantModes, setInstantModes] = useState([]);
  const [instantModesError, setInstantModesError] = useState([]);
  const [fieldsToBeExcluded, setFieldsToBeExcluded] = useState([]);
  const [uploadedFilesCount, setUploadedFilesCount] = useState({});
  const [activeTab, setActiveTab] = useState(1);
  const [maxDOJ, setMaxDOJ] = useState({});
  const [minDOL, setMinDOL] = useState({});
  const [otherVerificationSource, setOtherVerificationSource] = useState({});
  const [showOtherVerificationSource, setShowOtherVerificationSource] =
    useState({});
  const [otherVerificationError, setOtherVerificationError] = useState({});
  // Other designation
  const [otherDesignation, setOtherDesignation] = useState({});
  const [showOtherDesignation, setShowOtherDesignation] =
    useState({});
  const [otherDesignationError, setOtherDesignationError] = useState({});

  //Other reason for leaving
  const [otherReasonLeaving, setOtherReasonLeaving] = useState({});
  const [showOtherReasonLeaving, setShowOtherReasonLeaving] =
    useState({});
  const [otherReasonLeavingError, setOtherReasonLeavingError] = useState({});
  const [reasonOfLeavingOpt, setReasonOfLeavingOpt ] = useState({});
  const [showRemovePopup, setShowRemovePopup] = useState(false);
  const [checkIdToBeRemoved, setCheckIdToBeRemoved] = useState(null);
  const [errorIndexToBeRemoved, setErrorIndexToBeRemoved] = useState(null);
  const storeData = useSelector((state) => state.employmentSaveData);
  const previousEmployment = useSelector((state) => state.previousEmployment);
  const { employmentSaveData, loading: employmentSaveDataLoading } = storeData;
  const [catchIfAnyStatusIsNotCompleted, setCatchIfAnyStatusIsNotCompleted] =
    useState(0);
  const [checksDetailsStatus, setChecksDetailsStatus] = useState({});
  const [hasGap, setHasGap] = useState(false);
  const [gapReasonKey, setGapReasonKey] = useState("emp");
  const [gapData, setGapData] = useState({});
  const [finalCaseCheckId, setFinalCaseCheckId] = useState(null);
  const [finalDataToBeSent, setFinalDataToBeSent] = useState({});
  const [checkForAddEmployment, setCheckForAddEmployment] = useState(true);
  const [etypeErrorPopUp, setEtypeErrorPopUp] = useState(false);
  const [etypeInfo, setEtypeInfo] = useState(null);
  const [etypeShowGap, setETypeShowGap] = useState(null);

  const storeMRLDocument = useSelector((state) => state.MRLDocument || {});
  const {
    MRLDocumentData,
    loading: Loading,
    error: saveErr,
  } = storeMRLDocument;

  useEffect(() => {
    if (etypeInfo?.data) {
      if (etypeInfo?.data?.show_gap && etypeInfo?.data?.show_gap == "1") {
        setETypeShowGap(true);
      } else {
        setEtypeErrorPopUp(true);
      }
    }
  }, [etypeInfo]);
  useEffect(() => {
    if (previousEmployment?.previousEmploymentCountData?.data?.valid == 0) {
      setPreviousEmploymentCountPopUp(true);
    } else if (
      previousEmployment?.previousEmploymentCountData?.data?.valid == 1
    ) {
      setShowRemovePopup(true);
      dispatch(deletePrevEmploymentCountData());
    } else {
      setPreviousEmploymentCountPopUp(false);
    }
  }, [previousEmployment]);

  useEffect(() => {
    if (employment?.checksDetails) {
      let allTabchecked = Object.entries(employment.checksDetails)?.every(
        ([key, value]) => value?.check_status === 2
      );
      let val = allTabchecked ? 0 : 1;
      if (checkForAddEmployment == false) {
        val = 0;
      }
      setCatchIfAnyStatusIsNotCompleted(val);
    }
  }, [
    caseStatusCheckDetails,
    employment?.checksDetails,
    checkIdToBeRemoved,
    showRemovePopup,
    checkForAddEmployment,
  ]);

  useEffect(() => {
    if (
      typeof employmentSaveData?.data !== "undefined" &&
      employmentSaveData?.data !== null
    ) {
      // const checkStatus =
      //   emp.checksDetails[parseInt(employmentSaveData.activeTab - 1)]
      //     .check_status;
      if (employmentSaveData?.activeTab) {
        const currentTab = emp?.checksDetails[activeTab - 1];
        if (currentTab?.case_check_id) {
          setChecksDetailsStatus((prevState) => ({
            ...prevState,
            [`${currentTab?.case_check_id}`]: 2,
          }));
        }
      }

      if (employmentSaveData.activeTab == emp.checksDetails.length) {
        const groupId = employmentSaveData.data.group.group_id || employmentSaveData.data.group;
        if (groupId == "profile_preview") {
          navigate(`/case-initiation/profile-preview/${reference}`);
        } else {
          navigate(`/case-initiation/check-detail/${reference}/${groupId}/${emp.checksDetails.length}`);
        }
        dispatch(deleteSaveEmployment());
      } else {
        changeActiveTab(parseInt(employmentSaveData.activeTab + 1));
        dispatch(deleteSaveEmployment());
        window.scrollTo(0, 0);
      }
    }
  }, [employmentSaveData]);

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);

  useEffect(() => {
    setEmployment(emp);
    if (emp && emp.checksDetails) {
      // getMRLDocList(emp.checksDetails);
      emp.checksDetails.map((tab) =>
        console.log("tab...removed 2", tab.case_check_id)
      );
      // const checksDetailsLength = emp.checksDetails.length;
      if (redirectToTabOne == true) {
        navigate(`/case-initiation/check-detail/${reference}/4/1`);
        setActiveTab(1);
      }
    }
  }, [emp]);

  useEffect(() => {
    const checksDetails = employment.checksDetails;
    let errorArr = [];
    let onContractArr = [];
    let isSelfEmployedArr = [];
    let tillDateCheckedObj = {};
    let canConnectWithManagerArr = [];
    let canConnectWithManagerArr1 = [];
    let isDocProvidedCheckedObj = {};
    let requiredDocsList = [];
    checkInstantModes(checksDetails);
    setDateConditions(checksDetails);
    if (checksDetails) {
      for (var i in checksDetails) {
        let obj = {};
        for (var j in checksDetails[i].fields) {
          if (j === "is_document_provided") {
            isDocProvidedCheckedObj[parseInt(i)] =
              checksDetails[i].fields[j].field_value === "1" ||
              checksDetails[i]?.document_visibility !== 1
                ? true
                : false;
          }
          if (
            j.includes("email") &&
            checksDetails[i].fields[j].field_value !== ""
          ) {
            const isValid = validateEmail(
              checksDetails[i].fields[j].field_value
            );
            obj[j] = !isValid;
          }
          if (
            j == "company_contact_no" &&
            checksDetails[i].fields[j].field_value !== ""
          ) {
            const isValid = validateContactNumber(
              checksDetails[i].fields[j].field_value
            );
            obj[j] = !isValid;
          }

          if (
            j == "uan_number" &&
            checksDetails[i].fields[j].field_value !== ""
          ) {
            const isValid = validateUAN(checksDetails[i].fields[j].field_value);
            obj[j] = !isValid;
          }
          if (
            j == "ssn_number" &&
            checksDetails[i].fields[j].field_value !== ""
          ) {
            const isValid = validateSSN(checksDetails[i].fields[j].field_value);
            obj[j] = !isValid;
          }
          if (
            j == "is_ssn_country" &&
            checksDetails[i].fields[j].field_value !== ""
          ) {
            if(checksDetails[i].fields[j].field_value == "Yes")
            {setIsSSN(true)}
            else{setIsSSN(false)}
          }

          if (
            j == "employment_pan_number" &&
            checksDetails[i].fields[j].field_value !== ""
          ) {
            const isValid = validatePAN(checksDetails[i].fields[j].field_value);
            obj[j] = !isValid;
          }

          if (
            numbers711.includes(j) &&
            checksDetails[i].fields[j].field_value !== ""
          ) {
            const isValid = validateMobileNumber711(
              checksDetails[i].fields[j].field_value
            );
            obj[j] = !isValid;
          }

          if (
            alphabetsAndSpace.includes(j) &&
            checksDetails[i].fields[j].field_value !== ""
          ) {
            const isValid = validateAlphabetsAndSpace(
              checksDetails[i].fields[j].field_value
            );
            obj[j] = !isValid;
          }

          if (
            numericOnly.includes(j) &&
            checksDetails[i].fields[j].field_value !== ""
          ) {
            let isValid = validateNumeric(
              checksDetails[i].fields[j].field_value
            );
            // only for cost to company field
            if(isValid 
              && checksDetails[i].fields[j].field_value?.length >= 5 
              && checksDetails[i].fields[j].field_value > 0) {
              isValid = true;
            } else {
              isValid = false;
            }
            obj[j] = !isValid;
          }
          if (j === "connect_with_manager") {
            const canConnect =
              checksDetails[i].fields[j].field_value === "Yes" ||
              checksDetails[i].fields[j].field_value === ""
                ? true
                : false;
            canConnectWithManagerArr.push(canConnect);
          }
          if (j === "connect_with_manager1") {
            const canConnect =
              checksDetails[i].fields[j].field_value === "Yes" ||
              checksDetails[i].fields[j].field_value === ""
                ? true
                : false;
            canConnectWithManagerArr1.push(canConnect);
          }
          if (j === "till_date") {
            tillDateCheckedObj[parseInt(i)] =
              checksDetails[i].fields[j].field_value === "1" ? true : false;
          }

          if (j === "employed_in_company") {
            const isOnContract =
              checksDetails[i].fields[j].field_value === "On contract (agency)"
                ? true
                : false;
            onContractArr.push(isOnContract);
          }
          if (j === "work_status") {
            const isSelfEmployed =
              checksDetails[i].fields[j].field_value === "Self Employed"
                ? true
                : false;
            isSelfEmployedArr.push(isSelfEmployed);
          }
          if(j === "employee_code" && checksDetails[i].fields[j].field_value != "") {
            let isValid = checkEmployeeCode(checksDetails[i].fields[j].field_value);
            obj[j] = !isValid;
          }
        }
        errorArr.push(obj);
      }
    }
    for (let i = 0; i < errorArr.length; i++) {
      for (var j in checksDetails) {
        for (var k in checksDetails[j].required_documents) {
          if (checksDetails[j].required_documents[k].is_mandatory == 1) {
            errorArr[i][
              `${checksDetails[j].required_documents[k].document_name}`
            ] = false;
            if (i === activeTab - 1) {
              requiredDocsList.push(
                `${checksDetails[j].required_documents[k].document_name}`
              );
            }
          }
        }
      }
    }
    if (
      unsavedErrorData.length === 0 ||
      errorArr.length > unsavedErrorData.length
    ) {
      setErrorData(errorArr);
    } else {
      const index = activeTab - 1;
      const newErr = _.cloneDeep(unsavedErrorData);
      if (currentField) {
        newErr[index][currentField] = errorArr[index][currentField];
      }
      const isSelfEmployed = isSelfEmployedArr[index];
      if (isSelfEmployed) {
        for (var i in newErr[index]) {
          if (hrAndRMFields.includes(i) && i != "employee_code") { //IB-18729
            newErr[index][i] = false;
          }
        }
      }
      const isDocProvidedChecked = isDocProvidedCheckedObj[index];
      if (isDocProvidedChecked) {
        for (var i in newErr[index]) {
          if (requiredDocsList.includes(i)) {
            newErr[index][i] = false;
          }
        }
      }
      setErrorData(newErr);
    }

    setonContract(onContractArr);
    setIsSelfEmployed(isSelfEmployedArr);
    setTillDateChecked(tillDateCheckedObj);
    setCanConnectWithManager(canConnectWithManagerArr);
    setCanConnectWithManager1(canConnectWithManagerArr1);
    setIsDocProvidedChecked(isDocProvidedCheckedObj);

    getUploadedFilesCount(checksDetails);
  }, [employment, emp, unsavedErrorData]);

  useEffect(() => {
    if (
      typeof employment.checksDetails !== "undefined" &&
      employment.checksDetails !== null
    ) {
      //here find index of the tab with caseCheckId
      //finding which tab is active
      let foundIndex = null;
      var tabs = document.getElementsByClassName("nav-link tab");
      for (let i = 0; i < tabs.length; i++) {
        if (tabs[i].classList.contains("active")) {
          const dataCaseCh = tabs[i].dataset.casecheckid;
          if (dataCaseCh == active) {
            foundIndex = tabs[i].dataset.index;
          }
        }
      }
      // alert(foundIndex);
      if (active !== null && active !== undefined && foundIndex !== null) {
        console.log("navigation 499..")
        changeActiveTab(foundIndex, active);
      }
    }
  }, [employment, active]);

  // useEffect(() => {
  //   if (
  //     typeof employment.checksDetails !== "undefined" &&
  //     employment.checksDetails !== null
  //   ) {
  //     let findIndexOfIncompleteCheck = employment?.checksDetails?.findIndex(check => check?.check_status === 1);
  //     let findIndexOfCompleteCheck = employment?.checksDetails?.findIndex(check => check?.check_status === 2);
  //     let findIndexOfMigratedCheck = employment?.checksDetails?.findIndex(check => check?.check_status === 3);
  //     if (findIndexOfIncompleteCheck > -1) {
  //       changeActiveTab(findIndexOfIncompleteCheck + 1, active)
  //     } else if(findIndexOfCompleteCheck > -1) {
  //       changeActiveTab(findIndexOfCompleteCheck + 1, active)
  //     } else if(findIndexOfMigratedCheck > -1) {
  //       changeActiveTab(findIndexOfMigratedCheck + 1, active)
  //     }
  //   }
  // }, [employment]);

  const setDateConditions = (checksDetails) => {
    let dol = {};
    let doj = {};
    for (var i in checksDetails) {
      if (checksDetails[i].check_id == "41") {
        const joiningDate = checksDetails[i].fields["company_date_joining"]
          ? checksDetails[i].fields["company_date_joining"].field_value
          : "";
        const leavingDate = checksDetails[i].fields["company_date_of_leaving"]
          ? checksDetails[i].fields["company_date_of_leaving"].field_value
          : "";
        if (joiningDate !== "") {
          const [dd, mm, yyyy] = joiningDate.split("-");
          const futureDate = new Date(`${mm}/${dd}/${yyyy}`);
          futureDate.setDate(futureDate.getDate() + 1);
          dol[`${i}`] = futureDate;
        } else {
          dol[`${i}`] = null;
        }

        if (leavingDate !== "") {
          const [dd, mm, yyyy] = leavingDate.split("-");
          const pastDate = new Date(`${mm}/${dd}/${yyyy}`);
          pastDate.setDate(pastDate.getDate() - 1);
          doj[`${i}`] = pastDate;
        } else {
          doj[`${i}`] = null;
        }
      }
    }
    setMaxDOJ(doj);
    setMinDOL(dol);
  };
  const getUploadedFilesCount = (checksDetails) => {
    let uploadedFilesCount = {};
    for (let i in checksDetails) {
      let obj = {};
      for (let j in checksDetails[i].required_documents) {
        let count = 0;
        for (let k in checksDetails[i].uploaded_documents) {
          if (
            checksDetails[i].uploaded_documents[k].document_id ==
            checksDetails[i].required_documents[j].id
          ) {
            count++;
          }
        }
        obj[`${checksDetails[i].required_documents[j].id}`] = count;
      }
      const MRLRequiredDocs = MRLDocumentData ? MRLDocumentData[checksDetails[i]?.case_check_id]?.required_documents : null
      if(MRLRequiredDocs?.length) {
        for (let j in MRLRequiredDocs) {
          let count = 0;
          for (let k in checksDetails[i].uploaded_documents) {
            if (
              checksDetails[i].uploaded_documents[k].document_id ==
              MRLRequiredDocs[j].id
            ) {
              count++;
            }
          }
          obj[`${MRLRequiredDocs[j].id}`] = count;
        }
      }
      uploadedFilesCount[i] = obj;
    }
    setUploadedFilesCount(uploadedFilesCount);
  };

  const checkInstantModes = (checksDetails) => {
    let instantModesArr = [];
    let instantModesErrorArr = [];
    for (var i in checksDetails) {
      let arr = [];
      let errorArr = {};
      const instantModesData = checksDetails[i].instant_modes;
      for (let j = 0; j < instantModesData.length; j++) {
        arr.push(instantModesFields[instantModesData[j]]);
        for (
          let k = 0;
          k < instantFieldsMapping[instantModesData[j]].length;
          k++
        ) {
          errorArr[`${instantFieldsMapping[instantModesData[j]][k]}`] = false;
        }
      }
      instantModesArr.push(arr);
      instantModesErrorArr.push(errorArr);
    }

    setInstantModes(instantModesArr);
    setInstantModesError(instantModesErrorArr);
  };

  const updatePage = (redirect) => {
    reRenderAgain(employment, redirect);
  };

  const refreshPage = (redirect) => {
    refreshData(redirect, errorIndexToBeRemoved);
  };

  const handleRadioChange = (radioValues) => {
    const { dataset, value } = radioValues;
    setCurrentField(dataset.fieldname);
    if (dataset.fieldname === "work_status") {
      const selfEmployed = value === "Self Employed" ? true : false;
      let updatedIsSelfEmployed = _.cloneDeep(isSelfEmployed);
      updatedIsSelfEmployed[parseInt(dataset.checkdetailsindex)] = selfEmployed;
      setIsSelfEmployed(updatedIsSelfEmployed);
    }
    if (dataset.fieldname === "is_ssn_country") {
      const is_ssn_country = value === "Yes" ? true : false;
      setIsSSN(is_ssn_country);
    }
    if (dataset.fieldname === "employed_in_company") {
      const isOnContract = value === "On contract (agency)" ? true : false;
      let updatedOnContract = _.cloneDeep(onContract);
      updatedOnContract[parseInt(dataset.checkdetailsindex)] = isOnContract;
      setonContract(updatedOnContract);
    }
    if (
      dataset.fieldname === "connect_with_manager" ||
      dataset.fieldname === "connect_with_manager1"
    ) {
      if (dataset.fieldname === "connect_with_manager") {
        let updatedCanConnectWithManager = _.cloneDeep(canConnectWithManager);
        updatedCanConnectWithManager[parseInt(dataset.checkdetailsindex)] =
          !updatedCanConnectWithManager[parseInt(dataset.checkdetailsindex)];
        setCanConnectWithManager(updatedCanConnectWithManager);
      } else {
        let updatedCanConnectWithManager1 = _.cloneDeep(canConnectWithManager1);
        updatedCanConnectWithManager1[parseInt(dataset.checkdetailsindex)] =
          !updatedCanConnectWithManager1[parseInt(dataset.checkdetailsindex)];
        setCanConnectWithManager1(updatedCanConnectWithManager1);
      }
    }
    updateEmploymentDetails(dataset, value);
  };

  const handleTextChange = (textValues) => {
    const { dataset, value } = textValues;
    setCurrentField(dataset.fieldname);
    if (dataset.fieldname == "company_name") {
      if (value == "other") {
        const newArr = showOtherVerificationSource;
        newArr[parseInt(dataset.checkdetailsindex)] = true;
        setShowOtherVerificationSource(newArr);
      } else {
        const newArr = showOtherVerificationSource;
        newArr[parseInt(dataset.checkdetailsindex)] = false;
        setShowOtherVerificationSource(newArr);
      }
    }
    if (dataset.fieldname == "company_designation") {
      if (value == "other") {
        const newArr = showOtherDesignation;
        newArr[parseInt(dataset.checkdetailsindex)] = true;
        setShowOtherDesignation(newArr);
      } else {
        const newArr = showOtherDesignation;
        newArr[parseInt(dataset.checkdetailsindex)] = false;
        setShowOtherDesignation(newArr);
      }
    }

    if (dataset.fieldname == "reason_for_leaving") {
      if (value == "other") {
        const newArr = showOtherReasonLeaving;
        newArr[parseInt(dataset.checkdetailsindex)] = true;
        setShowOtherReasonLeaving(newArr);
      } else {
        const newArr = showOtherReasonLeaving;
        newArr[parseInt(dataset.checkdetailsindex)] = false;
        setShowOtherReasonLeaving(newArr);
      }
    }

    if (dataset.fieldname == "otherVerificationSource") {
      let newArr = _.cloneDeep(otherVerificationSource);
      newArr[dataset.checkdetailsindex] = value;
      setOtherVerificationSource(newArr);
      let arr = _.cloneDeep(otherVerificationError);
      if (
        value
      ) {
        arr[dataset.checkdetailsindex] = false;
        setOtherVerificationError(arr);
      } else {
        arr[dataset.checkdetailsindex] = true;
        setOtherVerificationError(arr);
      }
    } else if (dataset.fieldname == "otherDesignation") {
      let newArr = _.cloneDeep(otherDesignation);
      newArr[dataset.checkdetailsindex] = value;
      setOtherDesignation(newArr);
    } else if (dataset.fieldname == "otherReasonLeaving") {
      let newArr = _.cloneDeep(otherReasonLeaving);
      newArr[dataset.checkdetailsindex] = value;
      setOtherReasonLeaving(newArr);
    } else {
      updateEmploymentDetails(dataset, value);
    }
  };

  const handleSelectChange = (selectValues) => {
    const { dataset, value } = selectValues;
    setCurrentField(dataset.fieldname);
    updateEmploymentDetails(dataset, value);
      if (dataset.fieldname == "reason_for_leaving") {
        if (value == "Other") {
          const newArr = showOtherReasonLeaving;
          newArr[parseInt(dataset.checkdetailsindex)] = true;
          setShowOtherReasonLeaving(newArr);
        } else {
          const newArr = showOtherReasonLeaving;
          newArr[parseInt(dataset.checkdetailsindex)] = false;
          setShowOtherReasonLeaving(newArr);
        }
      }
  };

  const handleCheckboxChange = (checkboxValues) => {
    const { dataset, value } = checkboxValues;
    setCurrentField(dataset.fieldname);
    if (dataset.fieldname === "till_date") {
      let savedDate = dateFormat("DD-MM-YYYY", new Date());

      // const todayDate = new Date().toLocaleDateString();
      // const [day, month, year] = todayDate.split("/");
      // const savedDate = day + "-" + month + "-" + year;

      let updatedTillDateChecked = _.cloneDeep(tillDateChecked);
      const updatedValue =
        updatedTillDateChecked[parseInt(dataset.checkdetailsindex)] === true
          ? ""
          : "1";
      updatedTillDateChecked[parseInt(dataset.checkdetailsindex)] =
        !updatedTillDateChecked[parseInt(dataset.checkdetailsindex)];
      setTillDateChecked(updatedTillDateChecked);

      updateEmploymentDetails(dataset, updatedValue, savedDate);
    }
    if (dataset.fieldname === "is_document_provided") {
      let updatedIsDocProvidedChecked = _.cloneDeep(isDocProvidedChecked);
      const updatedValue =
        updatedIsDocProvidedChecked[parseInt(dataset.checkdetailsindex)] ===
        true
          ? ""
          : "1";
      updatedIsDocProvidedChecked[parseInt(dataset.checkdetailsindex)] =
        !updatedIsDocProvidedChecked[parseInt(dataset.checkdetailsindex)];
      setIsDocProvidedChecked(!updatedIsDocProvidedChecked);
      updateEmploymentDetails(dataset, updatedValue);
    }
  };

  const updateEmploymentDetails = (dataset, value, dolVal = "") => {
    const unsavedData = _.cloneDeep(errorData);
    handleUnsavedErrorData(unsavedData);
    let empDetails = _.cloneDeep(employment);
    if (dataset.fieldname.includes("email")) {
      checkEmailField(dataset, value);
    }
    if (dataset.fieldname == "company_contact_no") {
      checkCompanyContactNumber(dataset, value);
    }
    if (dataset.fieldname == "uan_number") {
      checkUANNumber(dataset, value);
    }
    if (dataset.fieldname == "ssn_number") {
      checkSSNNumber(dataset, value);
    }
    if (dataset.fieldname == "employment_pan_number") {
      checkPAN(dataset, value);
    }
    if (numbers711.includes(dataset.fieldname)) {
      checkMobileNumber711(dataset, value);
    }
    if (alphabetsAndSpace.includes(dataset.fieldname)) {
      checkAlphabetsAndSpace(dataset, value);
    }
    if (numericOnly.includes(dataset.fieldname)) {
      checkNumericOnly(dataset, value);
    }
    if(dataset.fieldname == "employee_code") {
      checkEmployeeCodeValidation(dataset, value);
    }
    empDetails.checksDetails[parseInt(dataset.checkdetailsindex)].fields[
      dataset.fieldname
    ].field_value = value;
    if (dataset.fieldname === "till_date") {
      empDetails.checksDetails[parseInt(dataset.checkdetailsindex)].fields[
        "company_date_of_leaving"
      ].field_value = dolVal;
    }
    setEmployment(empDetails);
  };

  const checkEmailField = (dataset, value) => {
    const isValid = validateEmail(value);
    changeErrorData(dataset, isValid);
  };

  const checkCompanyContactNumber = (dataset, value) => {
    const isValid = validateContactNumber(value);
    changeErrorData(dataset, isValid);
  };

  const checkUANNumber = (dataset, value) => {
    const isValid = validateUAN(value);
    changeErrorData(dataset, isValid);
  };
  const checkSSNNumber = (dataset, value) => {
    const isValid = validateSSN(value);
    changeErrorData(dataset, isValid);
  };

  const checkPAN = (dataset, value) => {
    const isValid = validatePAN(value);
    changeErrorData(dataset, isValid);
  };

  const checkMobileNumber711 = (dataset, value) => {
    const isValid = validateMobileNumber711(value);
    changeErrorData(dataset, isValid);
  };

  const checkAlphabetsAndSpace = (dataset, value) => {
    const isValid = validateAlphabetsAndSpace(value);
    changeErrorData(dataset, isValid);
  };

  const checkNumericOnly = (dataset, value) => {
    let isValid = validateNumeric(value);
    // only for cost to company field
    if(isValid && value?.length >= 5 && value > 0) {
      isValid = true;
    } else {
      isValid = false;
    }
    changeErrorData(dataset, isValid);
  };

  const checkEmployeeCodeValidation = (dataset, value) => {
    let isValid = checkEmployeeCode(value);
    changeErrorData(dataset, isValid);
  }
  const changeErrorData = (dataset, isValid) => {
    const updatedErrorData = _.cloneDeep(errorData);
    updatedErrorData[parseInt(dataset.checkdetailsindex)][dataset.fieldname] =
      !isValid;
    setErrorData(updatedErrorData);
  };

  const saveHandler = async (e, caseCheckId, index) => {
    setIsLoading(true);
    e.preventDefault();
    const fields = _.cloneDeep(employment.checksDetails[index - 1].fields);
    let newErrorData = _.cloneDeep(errorData);
    for (var i in fields) {
      const selfEmployed = isSelfEmployed[index - 1];
      let isFieldMandatory = fields[i].is_mandatory;
      if (selfEmployed) {
        isFieldMandatory = hrAndRMFields.includes(i)
          ? 0
          : fields[i].is_mandatory;
      }
      if (i == "till_date") {
        isFieldMandatory =
          fields["company_date_of_leaving"] &&
          fields["company_date_of_leaving"].field_value != ""
            ? 0
            : 1;
      }
      if (i == "ssn_number"){
        if(isSSN&& fields["is_ssn_country"] &&fields["ssn_number"].field_value.length !=9){newErrorData[index - 1][i] = true;}
        else{newErrorData[index - 1][i] = false;}
        
      }
      if (
        i == "company_name" &&
        showOtherVerificationSource[index - 1] == true
      ) {
        if (
          otherVerificationSource[index - 1] == "" ||
          otherVerificationSource[index - 1] == null
        ) {
          let arr = otherVerificationError;
          arr[index - 1] = true;
          setOtherVerificationError(arr);
        } else {
          let arr = otherVerificationError;
          arr[index - 1] = false;
          setOtherVerificationError(arr);
        }
      }
      if (
        i == "company_designation" &&
        showOtherDesignation[index - 1] == true
      ) {
        if (
          otherDesignation[index - 1] == "" ||
          otherDesignation[index - 1] == null
        ) {
          let arr = otherDesignationError;
          arr[index - 1] = true;
          setOtherDesignationError(arr);
        } else {
          let arr = otherDesignationError;
          arr[index - 1] = false;
          setOtherDesignationError(arr);
        }
      }
      if (
        i == "reason_for_leaving" &&
        showOtherReasonLeaving[index - 1] == true
      ) {
        if (
          otherReasonLeaving[index - 1] == "" ||
          otherReasonLeaving[index - 1] == null
        ) {
          let arr = otherReasonLeavingError;
          arr[index - 1] = true;
          setOtherReasonLeavingError(arr);
        } else {
          let arr = otherReasonLeavingError;
          arr[index - 1] = false;
          setOtherReasonLeavingError(arr);
        }
      }
      if (i == "company_date_of_leaving") {
        const isTillDateChecked =
          tillDateChecked[index - 1] && tillDateChecked[index - 1] == true
            ? true
            : false;
        if (isTillDateChecked) {
          isFieldMandatory = 0;
          newErrorData[index - 1][i] = false;
        }
      }
      if (i == "reliveing_letter_date") {
        const isTillDateChecked =
          tillDateChecked[index - 1] && tillDateChecked[index - 1] == true
            ? true
            : false;
        if (!isTillDateChecked) {
          isFieldMandatory = 0;
          newErrorData[index - 1][i] = false;
        }
      }
      if (canConnectWithManager.length > 0) {
        if (i == "manager_reason") {
          isFieldMandatory =
            canConnectWithManager[index - 1] == true
              ? 0
              : fields[i].is_mandatory;
        }
      }
      if (canConnectWithManager1.length > 0) {
        if (i == "manager_reason1") {
          isFieldMandatory =
            canConnectWithManager1[index - 1] == true
              ? 0
              : fields[i].is_mandatory;
        }
      }
      if (isFieldMandatory == 1 && !excludedFields.includes(i)) {
        if (
          fields[i].field_value?.trim() == "" ||
          fields[i].field_value == null
        ) {
          newErrorData[index - 1][i] = true;
        }
      }
    }
    if (isDocProvidedChecked[index - 1] == false) {
      let updatedCheckDetailsAPIData = {};
      try {
        let userLocalData = JSON.parse(
          localStorage.getItem("userVerificationCandidate")
        );
        const requestData = {
          token: userLocalData.id,
          group: 4,
          referenceNo: "1234567890",
        };

        const headers = {
          "Content-Type": "application/json",
          Username: "ibridge",
          Password: "ibridge@2020",
        };

        const { data } = await axios.post(
          FOLDERPATH + "/CandidateApi/checkDetail",
          requestData,
          {
            headers: headers,
          }
        );
        if (data?.data?.data) {
          updatedCheckDetailsAPIData = data.data.data;
        } else if (data?.status === "error") {
          const errorMsg = data?.message || "Something went Wrong!";
          toast.error(errorMsg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          window.scroll({ top: 0, left: 0, behavior: "smooth" });
          return;
        }
      } catch (err) {
        console.log(err);
      }

      const requiredDocs = _.cloneDeep(
        updatedCheckDetailsAPIData.checksDetails[index - 1].required_documents
      );
      const uploadedDocs = _.cloneDeep(
        updatedCheckDetailsAPIData.checksDetails[index - 1].uploaded_documents
      );
      const MRLRequiredDocs = MRLDocumentData ? MRLDocumentData[caseCheckId]?.required_documents : null
      let mrlGroupDocNotRequired = false;
      if(MRLRequiredDocs) {
        MRLRequiredDocs?.forEach(reqMRLDoc => {
          let docNotUploaded = true;
          const docID = reqMRLDoc.id;
          const isMandatory = reqMRLDoc.is_mandatory;
          for (var j in uploadedDocs) {
            if (uploadedDocs[j].document_id == docID) {
              docNotUploaded = false;
            }
          }
          if(isMandatory == 2) {
            if(!docNotUploaded){
              mrlGroupDocNotRequired = true;
            }
          }
        })
      }
      if(MRLRequiredDocs) {
        MRLRequiredDocs?.forEach(requiredDocument => {
          let docNotUploaded = true;
          const docID = requiredDocument.id;
          const isMandatory = requiredDocument.is_mandatory;
          for (var j in uploadedDocs) {
            if (uploadedDocs[j].document_id == docID) {
              docNotUploaded = false;
            }
          }
          if (isMandatory == 1) {
            newErrorData[index - 1][`${requiredDocument.document_name}`] =
              docNotUploaded;
          }
          if(isMandatory == 2) {
            if(docNotUploaded && !mrlGroupDocNotRequired){
              newErrorData[index - 1][`${requiredDocument.document_name}`] =
              docNotUploaded;
            }
          }
        })
      } else {
        for (var i in requiredDocs) {
          let docNotUploaded = true;
          const docID = requiredDocs[i].id;
          const isMandatory = requiredDocs[i].is_mandatory;
          for (var j in uploadedDocs) {
            if (uploadedDocs[j].document_id == docID) {
              docNotUploaded = false;
            }
          }
          if (isMandatory == 1) {
            newErrorData[index - 1][`${requiredDocs[i].document_name}`] =
              docNotUploaded;
          }
        }
      }
    }
    setErrorData(newErrorData);
    let isThereAnyError = false;
    for (var i in newErrorData[index - 1]) {
      if (
        newErrorData[index - 1][i] == true &&
        i != "till_date"
      ) {
        setIsLoading(false);
        isThereAnyError = true;
        break;
      }
    }
    if (otherVerificationError && otherVerificationError[index - 1]) {
      if (otherVerificationError[index - 1] == true) {
        setIsLoading(false);
        isThereAnyError = true;
      }
    }
    if (otherDesignationError && otherDesignationError[index - 1]) {
      if (otherDesignationError[index - 1] == true) {
        setIsLoading(false);
        isThereAnyError = true;
      }
    }
    if (otherReasonLeavingError && otherReasonLeavingError[index - 1]) {
      if (otherReasonLeavingError[index - 1] == true) {
        setIsLoading(false);
        isThereAnyError = true;
      }
    }
    if (isThereAnyError) {
      const errorMsg = "Please fill all required fields.";
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    }
    if (!isThereAnyError) {
      saveEmploymentDetails(index - 1, caseCheckId);
    }
  };

  const saveEmploymentDetails = (checksDetailsIndex, caseCheckId) => {
    setIsLoading(true);
    let savedDetailsObj = {};
    const currencyMasterData = JSON.parse(localStorage.getItem("currency"));
    console.log("currencyMasterData....", currencyMasterData)
    const fieldDetails = _.cloneDeep(
      employment.checksDetails[checksDetailsIndex].fields
    );
    for (var i in fieldDetails) {
      if (
        fieldDetails[i].field_value !== "" &&
        fieldDetails[i].field_value !== null
      ) {
        savedDetailsObj[`${fieldDetails[i].id}`] = fieldDetails[i].field_value;
      }
      if (
        fieldDetails[i].field_value === "" &&
        fieldDetails[i].label === "Till Date"
      ) {
        savedDetailsObj[`${fieldDetails[i].id}`] = fieldDetails[i].field_value; //needs to be done in general way
      }

      if (fieldDetails[i].label === "Date of leaving") {
        if (
          tillDateChecked[checksDetailsIndex] &&
          tillDateChecked[checksDetailsIndex] === true
        ) {
          savedDetailsObj[`${fieldDetails[i].id}`] = "";
        }
      }

      if(fieldDetails[i].label === "Date by when you can provide the reliveing letter") {
        if (
          !(tillDateChecked[checksDetailsIndex] &&
          tillDateChecked[checksDetailsIndex] === true)
        ) {
          savedDetailsObj[`${fieldDetails[i].id}`] = "";
        }
      }
      if(fieldDetails[i].label === "Salary Currency") {
        let currencyDt = ""
        if(currencyMasterData?.length){
          currencyDt = currencyMasterData?.find(currencyData => currencyData?.label?.currency == fieldDetails[i].field_value);
          if(currencyDt) {
            savedDetailsObj[`${fieldDetails[i].id}`] = currencyDt?.label?.short_name
          }
        }
      }
    }
    setIsLoading(false);
    let finalData = {};
    finalData[`${caseCheckId}`] = savedDetailsObj;
    finalData[`${caseCheckId}`]["group"] = "employment";
    finalData[`${caseCheckId}`]["company_contact_no_code"] =
      fieldDetails.company_contact_no
        ? fieldDetails.company_contact_no.country_code_value
        : "91";
    finalData[`${caseCheckId}`]["mobile_code_manager"] =
      fieldDetails.manager_mobile_no
        ? fieldDetails.manager_mobile_no.country_code_value
        : "91";
    finalData[`${caseCheckId}`]["mobile_code_manager1"] =
      fieldDetails.manager_mobile_no1
        ? fieldDetails.manager_mobile_no1.country_code_value
        : "91";
    finalData[`${caseCheckId}`]["mobile_code_hr"] = fieldDetails.hr_mobile_no
      ? fieldDetails.hr_mobile_no.country_code_value
      : "91";
    if (showOtherVerificationSource[checksDetailsIndex] == true) {
      finalData[`${caseCheckId}`]["otherVerificationSource"] =
        otherVerificationSource[checksDetailsIndex];
    }
    if (showOtherDesignation[checksDetailsIndex] == true) {
      finalData[`${caseCheckId}`]["17"] =
        otherDesignation[checksDetailsIndex];
    }
    if (showOtherReasonLeaving[checksDetailsIndex] == true) {
      finalData[`${caseCheckId}`]["77"] =
      otherReasonLeaving[checksDetailsIndex];
    }
    callSaveEmployment(caseCheckId, finalData, activeTab);
  };

  const callSaveEmployment = async (caseCheckId, finalData) => {
    const totalTabs = employment.checksDetails.length;
    if (totalTabs == activeTab) {
      finalData[`${caseCheckId}`]["is_final_tab"] = "1";
      if (
        employment.is_employment_validation &&
        employment.is_employment_validation == "1"
      ) {
        const result = await validationApi(caseCheckId, finalData);
        if (result) {
          if (result.data.valid && result.data.valid == "1") {
            if (employment.is_gap_reason && employment.is_gap_reason == "1") {
              const gapReasonResult = await gapReasonApi(
                caseCheckId,
                finalData,
                // result?.data?.show_declaration
              );
              if (
                gapReasonResult.data &&
                Object.keys(gapReasonResult.data).length > 0 &&
                gapReasonResult?.message!="No gap found."
              ) {
                setGapData(gapReasonResult.data);
                setFinalCaseCheckId(caseCheckId);
                setFinalDataToBeSent(finalData);
                if (
                  Object.keys(gapReasonResult.data.responseArr).includes(
                    "eduemp"
                  )
                ) {
                  setGapReasonKey("eduemp");
                }
                setHasGap(true);
              } else {
                dispatch(saveEmployment(caseCheckId, finalData, activeTab));
              }
            } else {
              dispatch(saveEmployment(caseCheckId, finalData, activeTab));
            }
          } else {
            // alert(result.data.msg);
            setFinalCaseCheckId(caseCheckId);
            setFinalDataToBeSent(finalData);
            setEtypeInfo(result);
            // setEtypeErrorPopUp(true);

            if (result.data.add_emp) {
              const condition = result.data.add_emp == 1 ? false : true;
              setCheckForAddEmployment(condition);
            } else {
              setCheckForAddEmployment(true);
            }
            return;
          }
        }
      } else if (employment.is_gap_reason && employment.is_gap_reason == "1") {
        const gapReasonResult = await gapReasonApi(caseCheckId, finalData);
        if (
          gapReasonResult.data &&
          Object.keys(gapReasonResult.data).length > 0
          && gapReasonResult?.message!="No gap found."
        ) {
          setGapData(gapReasonResult.data);
          setFinalCaseCheckId(caseCheckId);
          setFinalDataToBeSent(finalData);
          if (
            Object.keys(gapReasonResult.data.responseArr).includes("eduemp")
          ) {
            setGapReasonKey("eduemp");
          }
          setHasGap(true);
        } else {
          dispatch(saveEmployment(caseCheckId, finalData, activeTab));
        }
      } else {
        dispatch(saveEmployment(caseCheckId, finalData, activeTab));
      }
    } else {
      finalData[`${caseCheckId}`]["is_final_tab"] = "0";
      dispatch(saveEmployment(caseCheckId, finalData, activeTab));
    }
  };

  const validationApi = async (caseCheckID, checkData) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

      setIsLoading(true);

      const requestData = {
        token: userLocalData.id,
        case_check_id: caseCheckID,
        check_data: checkData,
      };

      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data: result } = await axios.post(
        FOLDERPATH + "/CandidateApi/empValidation",
        requestData,
        {
          headers: headers,
        }
      );
      setIsLoading(false);

      return result;
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      return null;
    }
  };

  const gapReasonApi = async (caseCheckID, checkData, show_declaration) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

      setIsLoading(true);

      const requestData = {
        token: userLocalData.id,
        case_check_id: caseCheckID,
        check_data: checkData,
        // show_declaration: show_declaration || 0,
      };

      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data: result } = await axios.post(
        FOLDERPATH + "/CandidateApi/GapReason",
        requestData,
        {
          headers: headers,
        }
      );
      setIsLoading(false);

      return result;
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      return null;
    }
  };
  const handleFileUpload = (mode, file, record) => {
    dispatch(uploadFileViaMultipart(mode, file, record));
  };

  const getCountHandler = (record) => {
    return 1;
  };

  const getUpdatedEmploymentData = () => {
    const unsavedData = _.cloneDeep(errorData);
    handleUnsavedErrorData(unsavedData);
    updatePage(false);
  };

  const handleSaveDate = (checkDetailsIndex, fieldName, savedDate) => {
    setCurrentField(fieldName);
    const unsavedData = _.cloneDeep(errorData);
    handleUnsavedErrorData(unsavedData);
    let updatedEmploymentDetails = _.cloneDeep(employment);
    for (var i in updatedEmploymentDetails.checksDetails[
      parseInt(checkDetailsIndex)
    ].fields) {
      if (i == fieldName) {
        updatedEmploymentDetails.checksDetails[
          parseInt(checkDetailsIndex)
        ].fields[i].field_value = savedDate;
      }
    }
    setEmployment(updatedEmploymentDetails);
  };

  const changeActiveTab = (index) => {
    if (
      typeof employment.checksDetails !== "undefined" &&
      employment.checksDetails !== null
    ) {
      if (index) {
        navigate(`/case-initiation/check-detail/${reference}/4/${index}`);
      }
    }
    setActiveTab(index);
  };

  const handleBack = () => {
    backHandler();
  };

  const closeRemovePopup = () => {
    setShowRemovePopup(false);
  };

  const proceedRemove = async () => {
    if (checkIdToBeRemoved) {
      await dispatch(removeEmployment(checkIdToBeRemoved));
      // window.location.reload();
      // updatePage(true);
      //  refreshPage(true);
      setCheckIdToBeRemoved(null);
      setErrorIndexToBeRemoved(null);
      setShowRemovePopup(false);
    }
  };

  const closePreEmpCount = () => {
    setPreviousEmploymentCountPopUp(false);
    dispatch(deletePrevEmploymentCountData());
  };

  const proceedPreEmpCount = () => {
    setShowRemovePopup(true);
    dispatch(deletePrevEmploymentCountData());
  };

  const handleEmploymentRemoveClick = (e, caseCheckId, index) => {
    e.preventDefault();
    setCheckIdToBeRemoved(caseCheckId);
    setErrorIndexToBeRemoved(index);
    dispatch(getPreviousEmploymentCount());
    // console.log("previous....",previousEmployment?.previousEmploymentCountData)
  };

  const handleCountryCode = (e) => {
    const unsavedData = _.cloneDeep(errorData);
    handleUnsavedErrorData(unsavedData);
    const { dataset, value } = e.target;
    let empDetails = _.cloneDeep(employment);
    empDetails.checksDetails[parseInt(dataset.checkdetailsindex)].fields[
      dataset.fieldname
    ].country_code_value = value;
    setEmployment(empDetails);
  };

  const closeGapPopUp = () => {
    setHasGap(false);
  };

  const handleGapReasonSubmit = (gapReasonData) => {
    setIsLoading(true);
    let newFinalData = _.cloneDeep(finalDataToBeSent);
    let newGapData = [];
    for (var i in gapReasonData) {
      let obj = {};
      let category = null;
      for (var j in gapReasonData[i]) {
        if (["label", "tenure_to", "tenure_from"].includes(j)) {
          obj[`gap_${j}`] = gapReasonData[i][j];
        } else {
          if (j == "category") {
            category = gapReasonData[i][j];
          }
          obj[`${j}`] = gapReasonData[i][j];
        }
      }
      obj["gap_type"] = category;
      newGapData.push(obj);
    }
    newFinalData[finalCaseCheckId]["GapReason"] = newGapData;
    dispatch(saveEmployment(finalCaseCheckId, newFinalData, activeTab));
  };

  const proceedTenureAlert = async () => {
    setETypeShowGap(false);
    const gapReasonResult = await gapReasonApi(
      finalCaseCheckId,
      finalDataToBeSent,
      // etypeInfo?.data?.show_declaration
    );
    setEtypeInfo(null);
    if (gapReasonResult.data && Object.keys(gapReasonResult.data).length > 0 && gapReasonResult?.message!="No gap found.") {
      setGapData(gapReasonResult.data);
      if (Object.keys(gapReasonResult.data.responseArr).includes("eduemp")) {
        setGapReasonKey("eduemp");
      }
      setHasGap(true);
    } else {
      dispatch(saveEmployment(finalCaseCheckId, finalDataToBeSent, activeTab));
    }
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };
  
  /** MRL DOC Code*/
  const checkDocApi = (payload, caseCheckId) => {
    // dispatch(getMRLDocument(payload, caseCheckId))
  }

  useEffect(() => {
    dispatch(getReasonOfLeavingOptions(setReasonCallback));
    return () => {
      dispatch(
        { type: "MRL_DOCUMENT_RESET" }
      )
    }
  },[])

  const setReasonCallback = (data) => {
    data.push({id: 0, reason: 'Other'});
    setReasonOfLeavingOpt(data);
  }

  const getMRLDocList = (checksDetails) => {
    Object.entries(checksDetails).forEach(([key, check]) => {
      if(check?.verification_source_id || MRLDocumentData[check?.case_check_id]) {
           checkDocApi({
                verification_type: 2,
                org_id: check?.verification_source_id || MRLDocumentData[check?.case_check_id]?.verificationSourceId,
                check_id: check?.check_id
              }, check.case_check_id)
      }
    });
  }
  

  return (
    <>
      {loading && <Loader />}
      {hasGap && (
        <EmploymentGaps
          gapData={gapData}
          closeGapPopUp={closeGapPopUp}
          handleGapReasonSubmit={handleGapReasonSubmit}
          gapReasonKey={gapReasonKey}
          gapName="Employment"
        />
      )}
      {showAddPopup == true && catchIfAnyStatusIsNotCompleted != 1 && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeAddPopup}
          title="Add Employment"
          description="Are you sure you want to add another employment?"
          proceedHandler={async (e) => {
            if(finalCaseCheckId && finalDataToBeSent && activeTab) {
              dispatch(saveEmployment(finalCaseCheckId, finalDataToBeSent, activeTab+1));
            }
            await proceedAdd();
            changeActiveTab(parseInt(activeTab + 1));
          }}
          isAdd={true}
        />
      )}
      {showAddPopup == true && catchIfAnyStatusIsNotCompleted == 1 && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeAddPopup}
          title="Add Employment"
          description="Save the existing employment, before adding a new one"
          proceedHandler={proceedAdd}
          isAdd={false}
          checkStatus={catchIfAnyStatusIsNotCompleted}
        />
      )}
      {showRemovePopup == true && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeRemovePopup}
          title="Remove Employment"
          description="Are you sure you want to remove this employment?"
          proceedHandler={proceedRemove}
          isAdd={false}
        />
      )}
      {showAlertPopUp && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={() => {
            setShowAlertPopUp(false);
            dispatch(deleteAddEmploymentData());
          }}
          title="Confirm"
          description="Maximum employments already added"
          proceedHandler={() => {
            setShowAlertPopUp(false);
            dispatch(deleteAddEmploymentData());
          }}
          isAdd={false}
          yesOption={"Okay"}
          noOption={"Cancel"}
        />
      )}
      {previousEmpoymentCountPopUp && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closePreEmpCount}
          title="Confirm"
          description={
            previousEmployment?.previousEmploymentCountData?.data?.msg
          }
          proceedHandler={proceedPreEmpCount}
          isAdd={false}
        />
      )}
      {etypeErrorPopUp && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={(e) => {
            e?.preventDefault();
            setEtypeErrorPopUp(false);
            setEtypeInfo(null);
          }}
          title={etypeInfo?.data?.etype}
          description={etypeInfo?.data?.msg}
          proceedHandler={(e) => {
            e?.preventDefault();
            setEtypeErrorPopUp(false);
            setEtypeInfo(null);
          }}
          isAdd={false}
        />
      )}
      {etypeShowGap && (
        <TenureAlertPopUp
          showModalBox={1}
          closePopup={(e) => {
            e?.preventDefault();
            setETypeShowGap(false);
            setEtypeInfo(null);
          }}
          title={etypeInfo?.data?.etype}
          description={etypeInfo?.data?.msg}
          proceedHandler={(e) => {
            e?.preventDefault();
            proceedTenureAlert();
          }}
          isAdd={false}
        />
      )}
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ marginTop: "20px" }}
      >
        <ul className="nav nav-tabs address-tabs" id="myTab" role="tablist">
          {activeTab &&
            Object.keys(employment).length > 0 &&
            employment.checksDetails &&
            employment.checksDetails.length === errorData.length &&
            Object.entries(employment.checksDetails).map(([key, value]) => {
              const index = parseInt(key) + 1;
              const caseCheckId = value.case_check_id;
              const caseCheckStatus = value.check_status;
              const checkName = value.IB_CHECK_NAME;
              let activeClass = "";
              if (typeof active !== "undefined") {
                if (active == index) {
                  activeClass = "active";
                }
              } else if (index === 1) {
                activeClass = "active";
              }

              let completeClass = "";
              if (
                caseCheckStatus === 2 ||
                caseCheckStatus === 3 ||
                (checksDetailsStatus &&
                  checksDetailsStatus[`${caseCheckId}`] === 2)
              ) {
                completeClass = "completed";
              }
              if(employment?.candidates?.is_currently_employed === 2 && value?.check_id === 58 && caseCheckStatus === 3) {
                return <></>
              }
              return (
                <li className={`nav-item ${completeClass}`} key={key}>
                  <a
                    className={`tab nav-link ${activeClass} ${completeClass}`}
                    id={`employment-tab-${index}`}
                    data-toggle="tab"
                    href={`#employment-${index}`}
                    role="tab"
                    aria-controls={`employment-${index}`}
                    aria-selected="true"
                    data-index={index - 1}
                    data-caseCheckId={caseCheckId}
                    onClick={(e) => changeActiveTab(index, caseCheckId)}
                  >
                    {(caseCheckStatus === 2 ||
                      caseCheckStatus === 3 ||
                      (checksDetailsStatus &&
                        checksDetailsStatus[`${caseCheckId}`] === 2)) && (
                      <i class="fas fa-check-circle mr-1"></i>
                    )}
                    {checkName}
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
      <hr />
      <div className="tab-content" id="myTabContent">
        {employment.checksDetails &&
          errorData.length > 0 &&
          employment.checksDetails.length === errorData.length &&
          Object.entries(employment.checksDetails).map(([key, value]) => {
            const index = parseInt(key) + 1;
            const caseCheckId = value.case_check_id;
            const clientId = employment.clientId;
            const checkID = value.check_id;
            const checkName = value.IB_CHECK_NAME;
            const documentVisibility = value.document_visibility;
            //mapping needs to be checked need fields array here
            const cisSlug = "verificationName_" + caseCheckId;

            let activeClass = "";
            if (typeof active !== "undefined") {
              if (active == index) {
                activeClass = "show active";
              }
            } else if (index === 1) {
              activeClass = "show active";
            }
            if(employment?.candidates?.is_currently_employed === 2 && checkID === 58 && value?.check_status === 3) {
              return <></>
            }
            return (
              <div
                className={`tab-pane fade ${activeClass}`}
                id={`employment-${index}`}
                role="tabpanel"
                aria-labelledby={`employment-tab-${index}`}
                key={key}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="fnt-smi-bld">{checkName}</h5>
                  {index !== 1 &&
                    checkID != "58" &&
                    employment.cross_btn_emp == 1 && (
                      <button
                        class="btn btn-outline-secondary mt-2 mb-2 mr-2"
                        onClick={(e) =>
                          handleEmploymentRemoveClick(e, caseCheckId, index - 1)
                        }
                      >
                        <i class="far fa-trash-alt mr-2"></i>
                        Remove
                      </button>
                    )}
                </div>
                <div className="row">
                  {value.fields.is_ssn_country ? (
                    <EMPRadio
                      name={`is_ssn_country_${caseCheckId}`}
                      id={`is_ssn_country_${caseCheckId}`}
                      fieldId={value.fields.is_ssn_country.ibridge_field_id}
                      label={value.fields.is_ssn_country.label}
                      isRequired={value.fields.is_ssn_country.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.is_ssn_country.ibridge_field_id}`}
                      options={
                        
                        {Yes: "Yes", No: "No"}
                      }
                      handleRadioChange={handleRadioChange}
                      checkDetailsIndex={key}
                      fieldName={"is_ssn_country"}
                      fieldValue={value.fields.is_ssn_country.field_value}
                      hasError={errorData[index - 1]["is_ssn_country"]}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="row">
                  {isSSN && value?.fields?.is_ssn_country&& (
                    <EMPText
                    name={`ssn_number_${caseCheckId}`}
                    id={`ssn_number_${caseCheckId}`}
                    fieldId={value.fields.ssn_number.ibridge_field_id}
                    label={value.fields.ssn_number.label}
                    isRequired={
                       value.fields.ssn_number.is_mandatory
                    }
                    errId={`err_${caseCheckId}_${value.fields.ssn_number.ibridge_field_id}`}
                    handleTextChange={handleTextChange}
                    checkDetailsIndex={key}
                    fieldName={"ssn_number"}
                    fieldValue={value.fields.ssn_number.field_value}
                    hasError={errorData[index - 1]["ssn_number"]}
                    note={true}
                  />
                  )}
                </div>
                <div className="row">
                  {value.fields.work_status ? (
                    <EMPRadio
                      name={`work_status_${caseCheckId}`}
                      id={`work_status_${caseCheckId}`}
                      fieldId={value.fields.work_status.ibridge_field_id}
                      label={value.fields.work_status.label}
                      isRequired={value.fields.work_status.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.work_status.ibridge_field_id}`}
                      options={
                        value.fields.work_status.getFieldDisplay.optionArray
                          .options
                      }
                      handleRadioChange={handleRadioChange}
                      checkDetailsIndex={key}
                      fieldName={"work_status"}
                      fieldValue={value.fields.work_status.field_value}
                      hasError={errorData[index - 1]["work_status"]}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <br />
                {isSelfEmployed[index - 1] == false && (
                  <>
                    <div className="row">
                      {value.fields.employed_in_company ? (
                        <EMPRadio
                          name={`employed_in_company_${caseCheckId}`}
                          id={`employed_in_company_${caseCheckId}`}
                          fieldId={
                            value.fields.employed_in_company.ibridge_field_id
                          }
                          label={value.fields.employed_in_company.label}
                          isRequired={
                            value.fields.employed_in_company.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.employed_in_company.ibridge_field_id}`}
                          options={
                            value.fields.employed_in_company.getFieldDisplay
                              .optionArray.options
                          }
                          handleRadioChange={handleRadioChange}
                          checkDetailsIndex={key}
                          fieldName={"employed_in_company"}
                          fieldValue={
                            value.fields.employed_in_company.field_value
                          }
                          hasError={errorData[index - 1]["employed_in_company"]}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                    <br />
                  </>
                )}
                {onContract.length > 0 &&
                  onContract[index - 1] === true &&
                  isSelfEmployed[index - 1] == false && (
                    <div
                      className="row"
                      style={{
                        marginLeft: "-15px",
                        marginBottom: "15px",
                        marginTop: "-5px",
                      }}
                    >
                      <div className="col-sm-8 col-md-12 col-xl-8">
                        <b>
                          Please provide the employment details as per your
                          payroll company.
                        </b>
                      </div>
                    </div>
                  )}
                <div className="row">
                  {value.fields.company_name ? (
                    <EMPAutoCompleteSelect
                      name={`company_name_${caseCheckId}`}
                      id={`company_name_${caseCheckId}`}
                      fieldId={value.fields.company_name.ibridge_field_id}
                      label={value.fields.company_name.label}
                      isRequired={value.fields.company_name.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.company_name.ibridge_field_id}`}
                      handleTextChange={(textValues, selectedOption) => {
                        handleTextChange(textValues);
                        checkDocApi({
                          verification_type: 2,
                          org_id: selectedOption?.value,
                          check_id: value.check_id
                        }, caseCheckId)
                      }}
                      checkDetailsIndex={key}
                      fieldName={"company_name"}
                      fieldValue={value.fields.company_name.field_value}
                      hasError={errorData[index - 1]["company_name"]}
                      verificationType={2}
                    />
                  ) : (
                    <></>
                  )}
                  {showOtherVerificationSource[key] &&
                    showOtherVerificationSource[key] == true && (
                      <EMPText
                        name={`otherVerificationSource_${caseCheckId}`}
                        id={`otherVerificationSource_${caseCheckId}`}
                        fieldId={null}
                        label={"Other Company Name"}
                        isRequired={1}
                        errId={null}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={key}
                        fieldName={"otherVerificationSource"}
                        fieldValue={
                          otherVerificationSource[key]
                            ? otherVerificationSource[key]
                            : ""
                        }
                        hasError={
                          otherVerificationError[key] &&
                          otherVerificationError[key] == true
                            ? true
                            : false
                        }
                      />
                    )}
                     {value.fields.company_designation ? (
                      <EMPAutoCompleteSelect
                      name={`company_designation_${caseCheckId}`}
                      id={`company_designation_${caseCheckId}`}
                      fieldId={value.fields.company_designation.ibridge_field_id}
                      label={value.fields.company_designation.label}
                      isRequired={value.fields.company_designation.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.company_designation.ibridge_field_id}`}
                      handleTextChange={(textValues, selectedOption) => {
                        handleTextChange(textValues);
                        checkDocApi({
                          verification_type: 2,
                          org_id: selectedOption?.value,
                          check_id: value.check_id
                        }, caseCheckId)
                      }}
                      checkDetailsIndex={key}
                      fieldName={"company_designation"}
                      fieldValue={value.fields.company_designation.field_value}
                      hasError={errorData[index - 1]["company_designation"]}
                      verificationType={2}
                    />
                  ) : (
                    <></>
                  )}  
                  {/* Other designation field */}
                  {showOtherDesignation[key] &&
                    showOtherDesignation[key] == true ? (
                    <EMPText
                      name={`otherDesignation_${caseCheckId}`}
                      id={`otherDesignation__${caseCheckId}`}
                      fieldId={
                        null
                      }
                      label={`Other Designation`}
                      isRequired={1}
                      errId={null}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"otherDesignation"}
                      fieldValue={
                        otherDesignation[key]
                          ? otherDesignation[key]
                          : ""
                      }
                      hasError={
                        otherDesignationError[key] &&
                        otherDesignationError[key] == true
                          ? true
                          : false
                      }
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.company_location ? (
                    <EMPText
                      name={`company_location_${caseCheckId}`}
                      id={`company_location_${caseCheckId}`}
                      fieldId={value.fields.company_location.ibridge_field_id}
                      label={value.fields.company_location.label}
                      isRequired={value.fields.company_location.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.company_location.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"company_location"}
                      fieldValue={value.fields.company_location.field_value}
                      hasError={errorData[index - 1]["company_location"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.company_contact_no ? (
                    <EMPText
                      name={`company_contact_no_${caseCheckId}`}
                      id={`company_contact_no_${caseCheckId}`}
                      fieldId={value.fields.company_contact_no.ibridge_field_id}
                      label={value.fields.company_contact_no.label}
                      isRequired={value.fields.company_contact_no.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.company_contact_no.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"company_contact_no"}
                      fieldValue={value.fields.company_contact_no.field_value}
                      hasError={errorData[index - 1]["company_contact_no"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.address_of_company ? (
                    <>
                      <EMPText
                        name={`address_of_company_${caseCheckId}`}
                        id={`address_of_company_${caseCheckId}`}
                        fieldId={
                          value.fields.address_of_company.ibridge_field_id
                        }
                        label={value.fields.address_of_company.label}
                        isRequired={
                          value.fields.address_of_company.is_mandatory
                        }
                        errId={`err_${caseCheckId}_${value.fields.address_of_company.ibridge_field_id}`}
                        divClass="col-sm-8 col-md-12 col-xl-8"
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={key}
                        fieldName={"address_of_company"}
                        fieldValue={value.fields.address_of_company.field_value}
                        hasError={errorData[index - 1]["address_of_company"]}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                  {value.fields.company_employment_type ? (
                    <EMPSimpleSelect
                      name={`company_employment_type_${caseCheckId}`}
                      id={`company_employment_type_${caseCheckId}`}
                      label={value.fields.company_employment_type.label}
                      autoComplete="off"
                      options={
                        value.fields.company_employment_type.getFieldDisplay
                          .optionArray.options
                      }
                      isRequired={
                        value.fields.company_employment_type.is_mandatory
                      }
                      caseCheckId={caseCheckId}
                      handleSelectChange={handleSelectChange}
                      checkDetailsIndex={key}
                      fieldName={"company_employment_type"}
                      fieldValue={
                        value.fields.company_employment_type.field_value
                      }
                      hasError={errorData[index - 1]["company_employment_type"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.company_nature_of_employment ? (
                    <EMPSimpleSelect
                      name={`company_nature_of_employment_${caseCheckId}`}
                      id={`company_nature_of_employment_${caseCheckId}`}
                      label={value.fields.company_nature_of_employment.label}
                      autoComplete="off"
                      options={
                        value.fields.company_nature_of_employment
                          .getFieldDisplay.optionArray.options
                      }
                      isRequired={
                        value.fields.company_nature_of_employment.is_mandatory
                      }
                      caseCheckId={caseCheckId}
                      handleSelectChange={handleSelectChange}
                      checkDetailsIndex={key}
                      fieldName={"company_nature_of_employment"}
                      fieldValue={
                        value.fields.company_nature_of_employment.field_value
                      }
                      hasError={
                        errorData[index - 1]["company_nature_of_employment"]
                      }
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.corporate_email_id ? (
                    <EMPText
                      name={`corporate_email_id_${caseCheckId}`}
                      id={`corporate_email_id_${caseCheckId}`}
                      fieldId={value.fields.corporate_email_id.ibridge_field_id}
                      label={value.fields.corporate_email_id.label}
                      isRequired={
                        instantModes[index - 1] &&
                        instantModes[index - 1].length > 0 &&
                        instantModes[index - 1].includes(
                          "Corporate Email ID Validation"
                        )
                          ? 1
                          : value.fields.corporate_email_id.is_mandatory
                      }
                      errId={`err_${caseCheckId}_${value.fields.corporate_email_id.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"corporate_email_id"}
                      fieldValue={value.fields.corporate_email_id.field_value}
                      hasError={errorData[index - 1]["corporate_email_id"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.company_department ? (
                    <EMPText
                      name={`company_department_${caseCheckId}`}
                      id={`company_department_${caseCheckId}`}
                      fieldId={value.fields.company_department.ibridge_field_id}
                      label={value.fields.company_department.label}
                      isRequired={value.fields.company_department.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.company_department.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"company_department"}
                      fieldValue={value.fields.company_department.field_value}
                      hasError={errorData[index - 1]["company_department"]}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="row">
                  {value.fields.company_date_joining ? (
                    <EMPDate
                      paramStartDate={null}
                      placeholder={value.fields.company_date_joining.label}
                      name={`company_date_joining_${caseCheckId}`}
                      id={`company_date_joining_${caseCheckId}`}
                      fieldId={
                        value.fields.company_date_joining.ibridge_field_id
                      }
                      label={value.fields.company_date_joining.label}
                      isRequired={
                        value.fields.company_date_joining.is_mandatory
                      }
                      errId={`err_${caseCheckId}_${value.fields.company_date_joining.ibridge_field_id}`}
                      intialStatus={0}
                      saveDate={handleSaveDate}
                      checkID={checkID}
                      maxDOJDate={maxDOJ[key]}
                      checkDetailsIndex={key}
                      fieldName={"company_date_joining"}
                      fieldValue={value.fields.company_date_joining.field_value}
                      hasError={errorData[index - 1]["company_date_joining"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.company_date_of_leaving &&
                  !(
                    tillDateChecked[index - 1] &&
                    tillDateChecked[index - 1] === true
                  ) ? (
                    <EMPDate
                      paramStartDate={null}
                      placeholder={value.fields.company_date_of_leaving.label}
                      name={`company_date_of_leaving_${caseCheckId}`}
                      id={`company_date_of_leaving_${caseCheckId}`}
                      fieldId={
                        value.fields.company_date_of_leaving.ibridge_field_id
                      }
                      label={value.fields.company_date_of_leaving.label}
                      isRequired={
                        value.fields.company_date_of_leaving.is_mandatory
                      }
                      errId={`err_${caseCheckId}_${value.fields.company_date_of_leaving.ibridge_field_id}`}
                      intialStatus={0}
                      isDisabled={
                        tillDateChecked[index - 1] &&
                        tillDateChecked[index - 1] === true
                          ? true
                          : false
                      }
                      saveDate={handleSaveDate}
                      checkDetailsIndex={key}
                      checkID={checkID}
                      minDateDOL={minDOL[key]}
                      fieldName={"company_date_of_leaving"}
                      fieldValue={
                        value.fields.company_date_of_leaving.field_value
                      }
                      hasError={errorData[index - 1]["company_date_of_leaving"]}
                    />
                  ) : (
                    <></>
                  )}

                  {value.fields.till_date ? (
                    <EMPCheckbox
                      name={`till_date_${caseCheckId}`}
                      id={`till_date_${caseCheckId}`}
                      fieldId={value.fields.till_date.ibridge_field_id}
                      label={value.fields.till_date.label}
                      isRequired={value.fields.till_date.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.till_date.ibridge_field_id}`}
                      handleCheckboxChange={handleCheckboxChange}
                      checkDetailsIndex={key}
                      fieldName={"till_date"}
                      fieldValue={value.fields.till_date.field_value}
                      hasError={errorData[index - 1]["till_date"]}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="row">
                  {value.fields.roles_responsibilities ? (
                    <EMPText
                      name={`roles_responsibilities_${caseCheckId}`}
                      id={`roles_responsibilities_${caseCheckId}`}
                      fieldId={
                        value.fields.roles_responsibilities.ibridge_field_id
                      }
                      label={value.fields.roles_responsibilities.label}
                      isRequired={
                        value.fields.roles_responsibilities.is_mandatory
                      }
                      errId={`err_${caseCheckId}_${value.fields.roles_responsibilities.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"roles_responsibilities"}
                      fieldValue={
                        value.fields.roles_responsibilities.field_value
                      }
                      hasError={errorData[index - 1]["roles_responsibilities"]}
                    />
                  ) : (
                    <></>
                  )}

                  {value.fields.extra_remarks ? (
                    <EMPText
                      name={`extra_remarks_${caseCheckId}`}
                      id={`extra_remarks_${caseCheckId}`}
                      fieldId={value.fields.extra_remarks.ibridge_field_id}
                      label={value.fields.extra_remarks.label}
                      isRequired={value.fields.extra_remarks.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.extra_remarks.ibridge_field_id}`}
                      divClass="col-sm-8 col-md-12 col-xl-8"
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"extra_remarks"}
                      fieldValue={value.fields.extra_remarks.field_value}
                      hasError={errorData[index - 1]["extra_remarks"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.location ? (
                    <EMPSimpleSelect
                      name={`location_${caseCheckId}`}
                      id={`location_${caseCheckId}`}
                      label={value.fields.location.label}
                      autoComplete="off"
                      options={states}
                      isRequired={value.fields.location.is_mandatory}
                      caseCheckId={caseCheckId}
                      handleSelectChange={handleSelectChange}
                      checkDetailsIndex={key}
                      fieldName={"location"}
                      fieldValue={value.fields.location.field_value}
                      hasError={errorData[index - 1]["location"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.salary_currency ? (
                    <EMPSimpleSelect
                      name={`salary_currency_${caseCheckId}`}
                      id={`salary_currency_${caseCheckId}`}
                      label={value.fields.salary_currency.label}
                      autoComplete="off"
                      options={currencies}
                      isRequired={value.fields.salary_currency.is_mandatory}
                      caseCheckId={caseCheckId}
                      handleSelectChange={handleSelectChange}
                      checkDetailsIndex={key}
                      fieldName={"salary_currency"}
                      fieldValue={value.fields.salary_currency.field_value}
                      hasError={errorData[index - 1]["salary_currency"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.annual_salary ? (
                    <EMPSimpleSelect
                      name={`annual_salary_${caseCheckId}`}
                      id={`annual_salary_${caseCheckId}`}
                      label={value.fields.annual_salary.label}
                      autoComplete="off"
                      options={
                        value.fields.annual_salary.getFieldDisplay.optionArray
                          .options
                      }
                      isRequired={value.fields.annual_salary.is_mandatory}
                      caseCheckId={caseCheckId}
                      handleSelectChange={handleSelectChange}
                      checkDetailsIndex={key}
                      fieldName={"annual_salary"}
                      fieldValue={value.fields.annual_salary.field_value}
                      hasError={errorData[index - 1]["annual_salary"]}
                    />
                  ) : (
                    <></>
                  )}

                  {value.fields.cost_to_company ? (
                    <EMPText
                      name={`cost_to_company_${caseCheckId}`}
                      id={`cost_to_company_${caseCheckId}`}
                      fieldId={value.fields.cost_to_company.ibridge_field_id}
                      label={value.fields.cost_to_company.label}
                      isRequired={value.fields.cost_to_company.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.cost_to_company.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"cost_to_company"}
                      fieldValue={value.fields.cost_to_company.field_value}
                      hasError={errorData[index - 1]["cost_to_company"]}
                    />
                  ) : (
                    <></>
                  )}

                  {value.fields.employee_code ? (
                    <EMPText
                      name={`employee_code_${caseCheckId}`}
                      id={`employee_code_${caseCheckId}`}
                      fieldId={value.fields.employee_code.ibridge_field_id}
                      label={value.fields.employee_code.label}
                      isRequired={
                        isSelfEmployed[index - 1] == true
                          ? 0
                          : value.fields.employee_code.is_mandatory
                      }
                      errId={`err_${caseCheckId}_${value.fields.employee_code.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"employee_code"}
                      fieldValue={value.fields.employee_code.field_value}
                      hasError={errorData[index - 1]["employee_code"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.grade ? (
                    <EMPText
                      name={`grade_${caseCheckId}`}
                      id={`grade_${caseCheckId}`}
                      fieldId={value.fields.grade.ibridge_field_id}
                      label={value.fields.grade.label}
                      isRequired={value.fields.grade.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.grade.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"grade"}
                      fieldValue={value.fields.grade.field_value}
                      hasError={errorData[index - 1]["grade"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.reason_for_leaving ? (
                    <EMPSimpleSelect
                    name={`reason_for_leaving_${caseCheckId}`}
                    id={`reason_for_leaving_${caseCheckId}`}
                    label={value.fields.reason_for_leaving.label}
                    autoComplete="off"
                    options={reasonOfLeavingOpt || {}}
                    isRequired={
                      value.fields.reason_for_leaving.is_mandatory
                    }
                    caseCheckId={caseCheckId}
                    handleSelectChange={handleSelectChange}
                    checkDetailsIndex={key}
                    fieldName={"reason_for_leaving"}
                    fieldValue={
                      value.fields.reason_for_leaving.field_value
                    }
                    hasError={errorData[index - 1]["reason_for_leaving"]}
                  />
                  //   <EMPAutoCompleteSelect
                  //   name={`reason_for_leaving_${caseCheckId}`}
                  //   id={`reason_for_leaving_${caseCheckId}`}
                  //   fieldId={value.fields.reason_for_leaving.ibridge_field_id}
                  //   label={value.fields.reason_for_leaving.label}
                  //   isRequired={value.fields.reason_for_leaving.is_mandatory}
                  //   errId={`err_${caseCheckId}_${value.fields.reason_for_leaving.ibridge_field_id}`}
                  //   handleTextChange={(textValues, selectedOption) => {
                  //     handleTextChange(textValues);
                  //     checkDocApi({
                  //       verification_type: 2,
                  //       org_id: selectedOption?.value,
                  //       check_id: value.check_id
                  //     }, caseCheckId)
                  //   }}
                  //   checkDetailsIndex={key}
                  //   fieldName={"reason_for_leaving"}
                  //   fieldValue={value.fields.reason_for_leaving.field_value}
                  //   hasError={errorData[index - 1]["reason_for_leaving"]}
                  //   verificationType={2}
                  // />
                  ) : (
                    <></>
                  )}
                  {/* other reason for leaving field */}
                  {showOtherReasonLeaving[key] &&
                    showOtherReasonLeaving[key] == true ? (
                    <EMPText
                      name={`otherReasonLeaving_${caseCheckId}`}
                      id={`otherReasonLeaving_${caseCheckId}`}
                      fieldId={
                        null
                      }
                      label={`Other Reason`}
                      isRequired={1}
                      errId={null}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"otherReasonLeaving"}
                      fieldValue={
                        otherReasonLeaving[key]
                          ? otherReasonLeaving[key]
                          : ""
                      }
                      hasError={
                        otherReasonLeavingError[key] &&
                        otherReasonLeavingError[key] == true
                          ? true
                          : false
                      }
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.uan_number ? (
                    <EMPText
                      name={`uan_number_${caseCheckId}`}
                      id={`uan_number_${caseCheckId}`}
                      fieldId={value.fields.uan_number.ibridge_field_id}
                      label={value.fields.uan_number.label}
                      isRequired={
                        instantModes[index - 1] &&
                        instantModes[index - 1].length > 0 &&
                        instantModes[index - 1].includes("UAN")
                          ? 1
                          : value.fields.uan_number.is_mandatory
                      }
                      errId={`err_${caseCheckId}_${value.fields.uan_number.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"uan_number"}
                      fieldValue={value.fields.uan_number.field_value}
                      hasError={errorData[index - 1]["uan_number"]}
                    />
                  ) : (
                    <></>
                  )}
                </div>

                {value.fields.reliveing_letter_date &&
                  !!(
                    tillDateChecked[index - 1] &&
                    tillDateChecked[index - 1] === true
                  ) ? (
                  <div className="row" style={{ marginLeft: "5px" }}>
                    <p>{value.fields.reliveing_letter_date.label}</p>
                  </div>
                ) : (
                  <></>
                )}

                <div className="row">
                  {value.fields.reliveing_letter_date &&
                  !!(
                    tillDateChecked[index - 1] &&
                    tillDateChecked[index - 1] === true
                  ) ? (
                    <EMPDate
                      paramStartDate={null}
                      placeholder={"Date"}
                      name={`reliveing_letter_date_${caseCheckId}`}
                      id={`reliveing_letter_date_${caseCheckId}`}
                      fieldId={
                        value.fields.reliveing_letter_date.ibridge_field_id
                      }
                      label={value.fields.reliveing_letter_date.label}
                      isRequired={
                        value.fields.reliveing_letter_date.is_mandatory
                      }
                      checkID={checkID}
                      errId={`err_${caseCheckId}_${value.fields.reliveing_letter_date.ibridge_field_id}`}
                      intialStatus={0}
                      saveDate={handleSaveDate}
                      checkDetailsIndex={key}
                      fieldName={"reliveing_letter_date"}
                      fieldValue={
                        value.fields.reliveing_letter_date.field_value
                      }
                      hasError={errorData[index - 1]["reliveing_letter_date"]}
                    />
                  ) : (
                    <></>
                  )}
                </div>

                {instantModes[index - 1] &&
                  instantModes[index - 1].length > 0 &&
                  instantModes[index - 1].includes("Form 16") && (
                    <>
                      <div className="row">
                        <h4
                          style={{
                            marginLeft: "15px",
                            marginBottom: "15px",
                            marginTop: "15px",
                          }}
                        >
                          Form 16 Details
                        </h4>
                      </div>
                      <div className="row">
                        {value.fields.employment_pan_number ? (
                          <EMPText
                            name={`employment_pan_number_${caseCheckId}`}
                            id={`employment_pan_number_${caseCheckId}`}
                            fieldId={
                              value.fields.employment_pan_number
                                .ibridge_field_id
                            }
                            label={value.fields.employment_pan_number.label}
                            isRequired={
                              value.fields.employment_pan_number.is_mandatory
                            }
                            errId={`err_${caseCheckId}_${value.fields.employment_pan_number.ibridge_field_id}`}
                            handleTextChange={handleTextChange}
                            checkDetailsIndex={key}
                            fieldName={"employment_pan_number"}
                            fieldValue={
                              value.fields.employment_pan_number.field_value
                            }
                            hasError={
                              errorData[index - 1]["employment_pan_number"]
                            }
                          />
                        ) : (
                          <></>
                        )}
                        {value.fields.employment_tan_number ? (
                          <EMPText
                            name={`employment_tan_number_${caseCheckId}`}
                            id={`employment_tan_number_${caseCheckId}`}
                            fieldId={
                              value.fields.employment_tan_number
                                .ibridge_field_id
                            }
                            label={value.fields.employment_tan_number.label}
                            isRequired={
                              value.fields.employment_tan_number.is_mandatory
                            }
                            errId={`err_${caseCheckId}_${value.fields.employment_tan_number.ibridge_field_id}`}
                            handleTextChange={handleTextChange}
                            checkDetailsIndex={key}
                            fieldName={"employment_tan_number"}
                            fieldValue={
                              value.fields.employment_tan_number.field_value
                            }
                            hasError={
                              errorData[index - 1]["employment_tan_number"]
                            }
                          />
                        ) : (
                          <></>
                        )}
                        {value.fields.employment_assessment_year ? (
                          <EMPText
                            name={`employment_assessment_year_${caseCheckId}`}
                            id={`employment_assessment_year_${caseCheckId}`}
                            fieldId={
                              value.fields.employment_assessment_year
                                .ibridge_field_id
                            }
                            label={
                              value.fields.employment_assessment_year.label
                            }
                            isRequired={
                              value.fields.employment_assessment_year
                                .is_mandatory
                            }
                            errId={`err_${caseCheckId}_${value.fields.employment_assessment_year.ibridge_field_id}`}
                            handleTextChange={handleTextChange}
                            checkDetailsIndex={key}
                            fieldName={"employment_assessment_year"}
                            fieldValue={
                              value.fields.employment_assessment_year
                                .field_value
                            }
                            hasError={
                              errorData[index - 1]["employment_assessment_year"]
                            }
                          />
                        ) : (
                          <></>
                        )}
                        {value.fields.employment_certificate_no ? (
                          <EMPText
                            name={`employment_certificate_no_${caseCheckId}`}
                            id={`employment_certificate_no_${caseCheckId}`}
                            fieldId={
                              value.fields.employment_certificate_no
                                .ibridge_field_id
                            }
                            label={value.fields.employment_certificate_no.label}
                            isRequired={
                              value.fields.employment_certificate_no
                                .is_mandatory
                            }
                            errId={`err_${caseCheckId}_${value.fields.employment_certificate_no.ibridge_field_id}`}
                            handleTextChange={handleTextChange}
                            checkDetailsIndex={key}
                            fieldName={"employment_certificate_no"}
                            fieldValue={
                              value.fields.employment_certificate_no.field_value
                            }
                            hasError={
                              errorData[index - 1]["employment_certificate_no"]
                            }
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-sm-4 col-md-12 col-xl-4">
                          <div className="form-group">
                            <EMPSingleFileUpload
                              inputType={8}
                              inputName={"form_16"}
                              inputValue={
                                value.fields.employment_pan_number.field_value
                              }
                              isInputMandatory={1}
                              inputLabel={"Form 16"}
                              index={key - 1}
                              handleFileUpload={handleFileUpload}
                              record={{
                                caseCheckId: caseCheckId,
                                docId: value.instant_mode_documents[3].id,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                {instantModes[index - 1] &&
                  instantModes[index - 1].length > 0 &&
                  instantModes[index - 1].includes(
                    "Employee Validation Via OTP"
                  ) && (
                    <>
                      <div className="row">
                        {value.fields.employment_cand_mobile_no ? (
                          <EMPText
                            name={`employment_cand_mobile_no_${caseCheckId}`}
                            id={`employment_cand_mobile_no_${caseCheckId}`}
                            fieldId={
                              value.fields.employment_cand_mobile_no
                                .ibridge_field_id
                            }
                            label={value.fields.employment_cand_mobile_no.label}
                            isRequired={
                              value.fields.employment_cand_mobile_no
                                .is_mandatory
                            }
                            errId={`err_${caseCheckId}_${value.fields.employment_cand_mobile_no.ibridge_field_id}`}
                            handleTextChange={handleTextChange}
                            checkDetailsIndex={key}
                            fieldName={"employment_cand_mobile_no"}
                            fieldValue={
                              value.fields.employment_cand_mobile_no.field_value
                            }
                            hasError={
                              errorData[index - 1]["employment_cand_mobile_no"]
                            }
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                    </>
                  )}

                {instantModes[index - 1] &&
                  instantModes[index - 1].length > 0 &&
                  instantModes[index - 1].includes(
                    "Bank Statement Analyser"
                  ) && (
                    <>
                      <div className="row">
                        {value.fields.employment_monthly_salary ? (
                          <EMPText
                            name={`employment_monthly_salary_${caseCheckId}`}
                            id={`employment_monthly_salary_${caseCheckId}`}
                            fieldId={
                              value.fields.employment_monthly_salary
                                .ibridge_field_id
                            }
                            label={value.fields.employment_monthly_salary.label}
                            isRequired={
                              value.fields.employment_monthly_salary
                                .is_mandatory
                            }
                            errId={`err_${caseCheckId}_${value.fields.employment_monthly_salary.ibridge_field_id}`}
                            handleTextChange={handleTextChange}
                            checkDetailsIndex={key}
                            fieldName={"employment_monthly_salary"}
                            fieldValue={
                              value.fields.employment_monthly_salary.field_value
                            }
                            hasError={
                              errorData[index - 1]["employment_monthly_salary"]
                            }
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-sm-4 col-md-12 col-xl-4">
                          <div className="form-group">
                            <EMPSingleFileUpload
                              inputType={8}
                              inputName={"bank_statement"}
                              inputValue={
                                value.fields.employment_pan_number.field_value
                              }
                              isInputMandatory={1}
                              inputLabel={"Bank Statement"}
                              index={key - 1}
                              handleFileUpload={handleFileUpload}
                              record={{
                                caseCheckId: caseCheckId,
                                docId: value.instant_mode_documents[4].id,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                {caseCheckId != "281" && caseCheckId != "282" && (
                  <>
                    <div className="row">
                      <h4
                        style={{
                          marginLeft: "15px",
                          marginBottom: "15px",
                          marginTop: "15px",
                        }}
                      >
                        Reporting Manager Details
                      </h4>
                    </div>
                    {clientId == "131479" && (
                      <div className="row">
                        <p>
                          (Please provide only the Active contact details as
                          this information will be used for verification)
                        </p>
                      </div>
                    )}
                    {clientId == "312004" && checkID == "58" && (
                      <div className="row">
                        <p>
                          Your Current Employer will be contacted post your
                          joining at Sophos
                        </p>
                      </div>
                    )}
                    <div className="row">
                      {value.fields.manager_first_name ? (
                        <EMPText
                          name={`manager_first_name_${caseCheckId}`}
                          id={`manager_first_name_${caseCheckId}`}
                          fieldId={
                            value.fields.manager_first_name.ibridge_field_id
                          }
                          label={value.fields.manager_first_name.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.manager_first_name.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.manager_first_name.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"manager_first_name"}
                          fieldValue={
                            value.fields.manager_first_name.field_value
                          }
                          hasError={errorData[index - 1]["manager_first_name"]}
                        />
                      ) : (
                        <></>
                      )}

                      {value.fields.manager_middle_name ? (
                        <EMPText
                          name={`manager_middle_name_${caseCheckId}`}
                          id={`manager_middle_name_${caseCheckId}`}
                          fieldId={
                            value.fields.manager_middle_name.ibridge_field_id
                          }
                          label={value.fields.manager_middle_name.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.manager_middle_name.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.manager_middle_name.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"manager_middle_name"}
                          fieldValue={
                            value.fields.manager_middle_name.field_value
                          }
                          hasError={errorData[index - 1]["manager_middle_name"]}
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.manager_last_name ? (
                        <EMPText
                          name={`manager_last_name_${caseCheckId}`}
                          id={`manager_last_name_${caseCheckId}`}
                          fieldId={
                            value.fields.manager_last_name.ibridge_field_id
                          }
                          label={value.fields.manager_last_name.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.manager_last_name.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.manager_last_name.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"manager_last_name"}
                          fieldValue={
                            value.fields.manager_last_name.field_value
                          }
                          hasError={errorData[index - 1]["manager_last_name"]}
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.manager_designation ? (
                        <EMPText
                          name={`manager_designation_${caseCheckId}`}
                          id={`manager_designation_${caseCheckId}`}
                          fieldId={
                            value.fields.manager_designation.ibridge_field_id
                          }
                          label={value.fields.manager_designation.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.manager_designation.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.manager_designation.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"manager_designation"}
                          fieldValue={
                            value.fields.manager_designation.field_value
                          }
                          hasError={errorData[index - 1]["manager_designation"]}
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.manager_email_id ? (
                        <EMPText
                          name={`manager_email_id_${caseCheckId}`}
                          id={`manager_email_id_${caseCheckId}`}
                          fieldId={
                            value.fields.manager_email_id.ibridge_field_id
                          }
                          label={value.fields.manager_email_id.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.manager_email_id.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.manager_email_id.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"manager_email_id"}
                          fieldValue={value.fields.manager_email_id.field_value}
                          hasError={errorData[index - 1]["manager_email_id"]}
                        />
                      ) : (
                        <></>
                      )}

                      {value.fields.manager_mobile_no ? (
                        <EMPText
                          name={`manager_mobile_no_${caseCheckId}`}
                          id={`manager_mobile_no_${caseCheckId}`}
                          fieldId={
                            value.fields.manager_mobile_no.ibridge_field_id
                          }
                          label={value.fields.manager_mobile_no.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.manager_mobile_no.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.manager_mobile_no.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"manager_mobile_no"}
                          fieldValue={
                            value.fields.manager_mobile_no.field_value
                          }
                          countryCodeValue={
                            value.fields.manager_mobile_no.country_code_value
                          }
                          hasError={errorData[index - 1]["manager_mobile_no"]}
                          countryCodeOptions={countryCodeOptions}
                          handleCountryCode={(e) => handleCountryCode(e)}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="row">
                      {value.fields.connect_with_manager ? (
                        <EMPRadio
                          name={`connect_with_manager_${caseCheckId}`}
                          id={`connect_with_manager_${caseCheckId}`}
                          fieldId={
                            value.fields.connect_with_manager.ibridge_field_id
                          }
                          label={value.fields.connect_with_manager.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.connect_with_manager.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.connect_with_manager.ibridge_field_id}`}
                          options={
                            value.fields.connect_with_manager.getFieldDisplay
                              .optionArray.options
                          }
                          handleRadioChange={handleRadioChange}
                          checkDetailsIndex={key}
                          fieldName={"connect_with_manager"}
                          fieldValue={
                            value.fields.connect_with_manager.field_value
                          }
                          hasError={
                            errorData[index - 1]["connect_with_manager"]
                          }
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                    {canConnectWithManager[index - 1] === false && (
                      <div className="row" style={{ marginTop: "15px" }}>
                        {value.fields.manager_reason ? (
                          <EMPText
                            name={`manager_reason_${caseCheckId}`}
                            id={`manager_reason_${caseCheckId}`}
                            fieldId={
                              value.fields.manager_reason.ibridge_field_id
                            }
                            label={value.fields.manager_reason.label}
                            isRequired={
                              isSelfEmployed[index - 1] == true
                                ? 0
                                : value.fields.manager_reason.is_mandatory
                            }
                            errId={`err_${caseCheckId}_${value.fields.manager_reason.ibridge_field_id}`}
                            handleTextChange={handleTextChange}
                            checkDetailsIndex={key}
                            fieldName={"manager_reason"}
                            fieldValue={value.fields.manager_reason.field_value}
                            hasError={errorData[index - 1]["manager_reason"]}
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                    )}
                    <div className="row">
                      {value.fields.reporting_manager_in_company ? (
                        <EMPRadio
                          name={`reporting_manager_in_company_${caseCheckId}`}
                          id={`reporting_manager_in_company_${caseCheckId}`}
                          fieldId={
                            value.fields.reporting_manager_in_company
                              .ibridge_field_id
                          }
                          label={
                            value.fields.reporting_manager_in_company.label
                          }
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.reporting_manager_in_company
                                  .is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.reporting_manager_in_company.ibridge_field_id}`}
                          options={
                            value.fields.reporting_manager_in_company
                              .getFieldDisplay.optionArray.options
                          }
                          handleRadioChange={handleRadioChange}
                          checkDetailsIndex={key}
                          fieldName={"reporting_manager_in_company"}
                          fieldValue={
                            value.fields.reporting_manager_in_company
                              .field_value
                          }
                          hasError={
                            errorData[index - 1]["reporting_manager_in_company"]
                          }
                        />
                      ) : (
                        <></>
                      )}
                    </div>

                    {value.fields.manager_first_name1 ? (
                      <div className="row">
                        <h4
                          style={{
                            marginLeft: "15px",
                            marginBottom: "15px",
                            marginTop: "15px",
                          }}
                        >
                          Reporting Manager 2 Details{" "}
                        </h4>
                      </div>
                    ) : (
                      <></>
                    )}

                    {clientId == "312004" && checkID == "58" && (
                      <div className="row">
                        <p>
                          Your Current Employer will be contacted post your
                          joining at Sophos
                        </p>
                      </div>
                    )}
                    <div className="row">
                      {value.fields.manager_first_name1 ? (
                        <EMPText
                          name={`manager_first_name1_${caseCheckId}`}
                          id={`manager_first_name1_${caseCheckId}`}
                          fieldId={
                            value.fields.manager_first_name1.ibridge_field_id
                          }
                          label={value.fields.manager_first_name1.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.manager_first_name1.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.manager_first_name1.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"manager_first_name1"}
                          fieldValue={
                            value.fields.manager_first_name1.field_value
                          }
                          hasError={errorData[index - 1]["manager_first_name1"]}
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.manager_middle_name1 ? (
                        <EMPText
                          name={`manager_middle_name1_${caseCheckId}`}
                          id={`manager_middle_name1_${caseCheckId}`}
                          fieldId={
                            value.fields.manager_middle_name1.ibridge_field_id
                          }
                          label={value.fields.manager_middle_name1.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.manager_middle_name1.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.manager_middle_name1.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"manager_middle_name1"}
                          fieldValue={
                            value.fields.manager_middle_name1.field_value
                          }
                          hasError={
                            errorData[index - 1]["manager_middle_name1"]
                          }
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.manager_last_name1 ? (
                        <EMPText
                          name={`manager_last_name1_${caseCheckId}`}
                          id={`manager_last_name1_${caseCheckId}`}
                          fieldId={
                            value.fields.manager_last_name1.ibridge_field_id
                          }
                          label={value.fields.manager_last_name1.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.manager_last_name1.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.manager_last_name1.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"manager_last_name1"}
                          fieldValue={
                            value.fields.manager_last_name1.field_value
                          }
                          hasError={errorData[index - 1]["manager_last_name1"]}
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.manager_designation1 ? (
                        <EMPText
                          name={`manager_designation1_${caseCheckId}`}
                          id={`manager_designation1_${caseCheckId}`}
                          fieldId={
                            value.fields.manager_designation1.ibridge_field_id
                          }
                          label={value.fields.manager_designation1.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.manager_designation1.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.manager_designation1.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"manager_designation1"}
                          fieldValue={
                            value.fields.manager_designation1.field_value
                          }
                          hasError={
                            errorData[index - 1]["manager_designation1"]
                          }
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.manager_email_id1 ? (
                        <EMPText
                          name={`manager_email_id1_${caseCheckId}`}
                          id={`manager_email_id1_${caseCheckId}`}
                          fieldId={
                            value.fields.manager_email_id1.ibridge_field_id
                          }
                          label={value.fields.manager_email_id1.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.manager_email_id1.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.manager_email_id1.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"manager_email_id1"}
                          fieldValue={
                            value.fields.manager_email_id1.field_value
                          }
                          hasError={errorData[index - 1]["manager_email_id1"]}
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.manager_mobile_no1 ? (
                        <EMPText
                          name={`manager_mobile_no1_${caseCheckId}`}
                          id={`manager_mobile_no1_${caseCheckId}`}
                          fieldId={
                            value.fields.manager_mobile_no1.ibridge_field_id
                          }
                          label={value.fields.manager_mobile_no1.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.manager_mobile_no1.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.manager_mobile_no1.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"manager_mobile_no1"}
                          fieldValue={
                            value.fields.manager_mobile_no1.field_value
                          }
                          countryCodeValue={
                            value.fields.manager_mobile_no1.country_code_value
                          }
                          hasError={errorData[index - 1]["manager_mobile_no1"]}
                          countryCodeOptions={countryCodeOptions}
                          handleCountryCode={(e) => handleCountryCode(e)}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="row">
                      {value.fields.connect_with_manager1 ? (
                        <EMPRadio
                          name={`connect_with_manager1_${caseCheckId}`}
                          id={`connect_with_manager1_${caseCheckId}`}
                          fieldId={
                            value.fields.connect_with_manager1.ibridge_field_id
                          }
                          label={value.fields.connect_with_manager1.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.connect_with_manager1.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.connect_with_manager1.ibridge_field_id}`}
                          options={
                            value.fields.connect_with_manager1.getFieldDisplay
                              .optionArray.options
                          }
                          handleRadioChange={handleRadioChange}
                          checkDetailsIndex={key}
                          fieldName={"connect_with_manager1"}
                          fieldValue={
                            value.fields.connect_with_manager1.field_value
                          }
                          hasError={
                            errorData[index - 1]["connect_with_manager1"]
                          }
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                    {canConnectWithManager1[index - 1] === false && (
                      <div className="row" style={{ marginTop: "15px" }}>
                        {value.fields.manager_reason1 ? (
                          <EMPText
                            name={`manager_reason1_${caseCheckId}`}
                            id={`manager_reason1_${caseCheckId}`}
                            fieldId={
                              value.fields.manager_reason1.ibridge_field_id
                            }
                            label={value.fields.manager_reason1.label}
                            isRequired={
                              isSelfEmployed[index - 1] == true
                                ? 0
                                : value.fields.manager_reason1.is_mandatory
                            }
                            errId={`err_${caseCheckId}_${value.fields.manager_reason1.ibridge_field_id}`}
                            handleTextChange={handleTextChange}
                            checkDetailsIndex={key}
                            fieldName={"manager_reason1"}
                            fieldValue={
                              value.fields.manager_reason1.field_value
                            }
                            hasError={errorData[index - 1]["manager_reason1"]}
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                    )}
                    <div className="row">
                      {value.fields.reporting_manager_in_company1 ? (
                        <EMPRadio
                          name={`reporting_manager_in_company1_${caseCheckId}`}
                          id={`reporting_manager_in_company1_${caseCheckId}`}
                          fieldId={
                            value.fields.reporting_manager_in_company1
                              .ibridge_field_id
                          }
                          label={
                            value.fields.reporting_manager_in_company1.label
                          }
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.reporting_manager_in_company1
                                  .is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.reporting_manager_in_company1.ibridge_field_id}`}
                          options={
                            value.fields.reporting_manager_in_company1
                              .getFieldDisplay.optionArray.options
                          }
                          handleRadioChange={handleRadioChange}
                          checkDetailsIndex={key}
                          fieldName={"reporting_manager_in_company1"}
                          fieldValue={
                            value.fields.reporting_manager_in_company1
                              .field_value
                          }
                          hasError={
                            errorData[index - 1][
                              "reporting_manager_in_company1"
                            ]
                          }
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                    {
                      value.fields.hr_first_name && <div className="row">
                      <h4
                        style={{
                          marginLeft: "15px",
                          marginBottom: "15px",
                          marginTop: "15px",
                        }}
                      >
                        HR Details
                      </h4>
                    </div>
                    }
                    {clientId == "131479" && (
                      <div className="row">
                        <p>
                          (Please provide only the Active contact details as
                          this information will be used for verification)
                        </p>
                      </div>
                    )}
                    {clientId == "312004" && checkID == "58" && (
                      <div className="row">
                        <p>
                          Your Current Employer will be contacted post your
                          joining at Sophos
                        </p>
                      </div>
                    )}
                    <div className="row">
                      {value.fields.hr_first_name ? (
                        <EMPText
                          name={`hr_first_name_${caseCheckId}`}
                          id={`hr_first_name_${caseCheckId}`}
                          fieldId={value.fields.hr_first_name.ibridge_field_id}
                          label={value.fields.hr_first_name.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.hr_first_name.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.hr_first_name.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"hr_first_name"}
                          fieldValue={value.fields.hr_first_name.field_value}
                          hasError={errorData[index - 1]["hr_first_name"]}
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.hr_middle_name ? (
                        <EMPText
                          name={`hr_middle_name_${caseCheckId}`}
                          id={`hr_middle_name_${caseCheckId}`}
                          fieldId={value.fields.hr_middle_name.ibridge_field_id}
                          label={value.fields.hr_middle_name.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.hr_middle_name.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.hr_middle_name.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"hr_middle_name"}
                          fieldValue={value.fields.hr_middle_name.field_value}
                          hasError={errorData[index - 1]["hr_middle_name"]}
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.hr_last_name ? (
                        <EMPText
                          name={`hr_last_name_${caseCheckId}`}
                          id={`hr_last_name_${caseCheckId}`}
                          fieldId={value.fields.hr_last_name.ibridge_field_id}
                          label={value.fields.hr_last_name.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.hr_last_name.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.hr_last_name.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"hr_last_name"}
                          fieldValue={value.fields.hr_last_name.field_value}
                          hasError={errorData[index - 1]["hr_last_name"]}
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.hr_designation ? (
                        <EMPText
                          name={`hr_designation_${caseCheckId}`}
                          id={`hr_designation_${caseCheckId}`}
                          fieldId={value.fields.hr_designation.ibridge_field_id}
                          label={value.fields.hr_designation.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.hr_designation.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.hr_designation.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"hr_designation"}
                          fieldValue={value.fields.hr_designation.field_value}
                          hasError={errorData[index - 1]["hr_designation"]}
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.hr_company_name ? (
                        <EMPText
                          name={`hr_company_name_${caseCheckId}`}
                          id={`hr_company_name_${caseCheckId}`}
                          fieldId={
                            value.fields.hr_company_name.ibridge_field_id
                          }
                          label={value.fields.hr_company_name.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.hr_company_name.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.hr_company_name.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"hr_company_name"}
                          fieldValue={value.fields.hr_company_name.field_value}
                          hasError={errorData[index - 1]["hr_company_name"]}
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.hr_mobile_no ? (
                        <EMPText
                          name={`hr_mobile_no_${caseCheckId}`}
                          id={`hr_mobile_no_${caseCheckId}`}
                          fieldId={value.fields.hr_mobile_no.ibridge_field_id}
                          label={value.fields.hr_mobile_no.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.hr_mobile_no.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.hr_mobile_no.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"hr_mobile_no"}
                          fieldValue={value.fields.hr_mobile_no.field_value}
                          countryCodeValue={
                            value.fields.hr_mobile_no.country_code_value
                          }
                          hasError={errorData[index - 1]["hr_mobile_no"]}
                          countryCodeOptions={countryCodeOptions}
                          handleCountryCode={(e) => handleCountryCode(e)}
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.hr_email_id ? (
                        <EMPText
                          name={`hr_email_id_${caseCheckId}`}
                          id={`hr_email_id_${caseCheckId}`}
                          fieldId={value.fields.hr_email_id.ibridge_field_id}
                          label={value.fields.hr_email_id.label}
                          isRequired={
                            isSelfEmployed[index - 1] == true
                              ? 0
                              : value.fields.hr_email_id.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.hr_email_id.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={key}
                          fieldName={"hr_email_id"}
                          fieldValue={value.fields.hr_email_id.field_value}
                          hasError={errorData[index - 1]["hr_email_id"]}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                )}
                {(documentVisibility == 1 || (MRLDocumentData && MRLDocumentData[caseCheckId] && 
                  MRLDocumentData[caseCheckId]?.required_documents)) && (
                  <>
                    <h6 className="fnt-smi-bld mb-0">Upload Files</h6>
                    {/* <small>JPG, PDF, PNG, JPEG formats are supported</small> */}
                  </>
                )}
                {
                  MRLDocumentData && MRLDocumentData[caseCheckId] &&
                  MRLDocumentData[caseCheckId]?.required_documents &&
                  Object.entries(MRLDocumentData[caseCheckId]?.required_documents)?.map(
                    ([key, value]) => {
                      const totalCount =
                      uploadedFilesCount[parseInt(index - 1)] &&
                      uploadedFilesCount[parseInt(index - 1)][value.id]
                        ? uploadedFilesCount[parseInt(index - 1)][value.id]
                        : 0;
                      return (
                        <>
                          <EMPMultipleUpload
                            name={value.id}
                            id={`${caseCheckId}-${value.id}`}
                            title={value.document_name}
                            record={{
                              caseCheckId: caseCheckId,
                              docId: value.id,
                            }}
                            totalCount={totalCount}
                            getCount={getCountHandler}
                            getUpdatedEmploymentData={getUpdatedEmploymentData}
                            isMandatory={!!(value.is_mandatory == 1)}
                          />

                          {errorData[index - 1][`${value?.document_name}`] &&
                            totalCount == 0 &&
                            (value.is_mandatory == 1 || value.is_mandatory == 2)&& (
                              <p className="err text-danger">
                                This is a required field.
                              </p>
                            )}
                        </>
                      );
                    })
                }

                {!(MRLDocumentData && MRLDocumentData[caseCheckId]?.required_documents) && documentVisibility == 1 &&
                  value?.required_documents &&
                  Object.entries(value.required_documents).map(
                    ([key, value]) => {
                      const totalCount =
                        uploadedFilesCount[parseInt(index - 1)] &&
                        uploadedFilesCount[parseInt(index - 1)][value.id]
                          ? uploadedFilesCount[parseInt(index - 1)][value.id]
                          : 0;
                      return (
                        <>
                          <EMPMultipleUpload
                            name={value.id}
                            id={`${caseCheckId}-${value.id}`}
                            title={value.document_name}
                            record={{
                              caseCheckId: caseCheckId,
                              docId: value.id,
                            }}
                            totalCount={totalCount}
                            getCount={getCountHandler}
                            getUpdatedEmploymentData={getUpdatedEmploymentData}
                            isMandatory={!!(value.is_mandatory == 1)}
                          />

                          {errorData[index - 1][`${value?.document_name}`] &&
                            totalCount == 0 &&
                            value.is_mandatory == 1 && (
                              <p className="err text-danger">
                                This is a required field.
                              </p>
                            )}
                        </>
                      );
                    }
                  )}

                {/* <EMPMultipleUpload
                  name="salary_clip"
                  id="salary_clip"
                  title="Salary Slip containing Emp ID"
                  title={
                    clientId == "327924"
                      ? "LAST 3 SALARY SLIPS"
                      : "Salary Slip containing Emp ID"
                  }
                  record={{
                    caseCheckId: caseCheckId,
                    docId: value.required_documents[0].id,
                  }}
                  totalCount={
                    uploadedFilesCount[parseInt(index - 1)] &&
                    uploadedFilesCount[parseInt(index - 1)][
                      value.required_documents[0].id
                    ]
                      ? uploadedFilesCount[parseInt(index - 1)][
                          value.required_documents[0].id
                        ]
                      : 0
                  }
                  getCount={getCountHandler}
                  getUpdatedEmploymentData={getUpdatedEmploymentData}
                  isMandatory={
                    isDocProvidedChecked[index - 1] &&
                    isDocProvidedChecked[index - 1]
                      ? false
                      : value.required_documents[0].is_mandatory == "1"
                      ? true
                      : false
                  }
                />
                {errorData[index - 1]["Salary Slip containing Emp ID"] && (
                  <p className="err text-danger">This is a required field.</p>
                )}
                <EMPMultipleUpload
                  name="appointment_letter"
                  id="appointment_letter"
                  title="Appointment Letter"
                  record={{
                    caseCheckId: caseCheckId,
                    docId: value.required_documents[1].id,
                  }}
                  totalCount={
                    uploadedFilesCount[parseInt(index - 1)] &&
                    uploadedFilesCount[parseInt(index - 1)][
                      value.required_documents[1].id
                    ]
                      ? uploadedFilesCount[parseInt(index - 1)][
                          value.required_documents[1].id
                        ]
                      : 0
                  }
                  getCount={getCountHandler}
                  getUpdatedEmploymentData={getUpdatedEmploymentData}
                  isMandatory={
                    isDocProvidedChecked[index - 1] &&
                    isDocProvidedChecked[index - 1]
                      ? false
                      : value.required_documents[1].is_mandatory == "1"
                      ? true
                      : false
                  }
                />
                {errorData[index - 1]["Appointment Letter"] && (
                  <p className="err text-danger">This is a required field.</p>
                )}
                <EMPMultipleUpload
                  name="experience_letter"
                  id="experience_letter"
                  title={
                    clientId == "327924"
                      ? "Relieving Letter"
                      : "Experience Letter"
                  }
                  record={{
                    caseCheckId: caseCheckId,
                    docId: value.required_documents[2].id,
                  }}
                  totalCount={
                    uploadedFilesCount[parseInt(index - 1)] &&
                    uploadedFilesCount[parseInt(index - 1)][
                      value.required_documents[2].id
                    ]
                      ? uploadedFilesCount[parseInt(index - 1)][
                          value.required_documents[2].id
                        ]
                      : 0
                  }
                  getCount={getCountHandler}
                  getUpdatedEmploymentData={getUpdatedEmploymentData}
                  isMandatory={
                    isDocProvidedChecked[index - 1] &&
                    isDocProvidedChecked[index - 1]
                      ? false
                      : value.required_documents[2].is_mandatory == "1"
                      ? true
                      : false
                  }
                />
                {errorData[index - 1]["Experience Letter"] && (
                  <p className="err text-danger">This is a required field.</p>
                )} */}
                {clientId == "219325" && checkID == "58" && (
                  <div className="row">
                    <p>
                      Please upload an email or any proof of leaving if you do
                      not have not received the relieving letter yet
                    </p>
                  </div>
                )}
                {clientId == "275022" && (
                  <div className="row">
                    <p>
                      Please share the documents with the concerned HR
                      Representative.
                    </p>
                  </div>
                )}
                {documentVisibility == 1 &&
                  !documentCheckboxDisabledClients.includes(clientId) &&
                  // value.upload_docs_later_checkbox &&
                  value.upload_docs_later_checkbox == 1 && (
                    <div className="row mt-3">
                      {value.fields.is_document_provided ? (
                        <EMPCheckbox
                          name={`is_document_provided_${caseCheckId}`}
                          id={`is_document_provided_${caseCheckId}`}
                          fieldId={
                            value.fields.is_document_provided.ibridge_field_id
                          }
                          label={value.fields.is_document_provided.label}
                          isRequired={
                            value.fields.is_document_provided.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.is_document_provided.ibridge_field_id}`}
                          handleCheckboxChange={handleCheckboxChange}
                          checkDetailsIndex={key}
                          fieldName={"is_document_provided"}
                          fieldValue={
                            value.fields.is_document_provided.field_value
                          }
                          hasError={
                            errorData[index - 1]["is_document_provided"]
                          }
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  )}

                <div className="row mt-3">
                  <div className="col-auto d-flex justify-content-between">
                    {/* <button
                      className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2"
                      onClick={handleBack}
                    >
                      Back
                    </button> */}
                    <button
                      className="btn btn-primary btn-lg btn-block mt-3"
                      onClick={(e) => saveHandler(e, caseCheckId, index)}
                    >
                      Save
                    </button>
                  </div>
                </div>
                {/* {employment.showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        Submit for Preview
                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )} */}
              </div>
            );
          })}
      </div>
    </>
  );
};

export default MainForm;
